<template>
  <div class="wrap-page" :class="{'cashflow': $route.path.indexOf('cashflow') >= 0,'wrap-page-accounting-invoice': $route.path.indexOf('accounting-invoice') >= 0 || (getPermissionShowDopColumnsFull().has_permission && getPermissionShowDopColumnsFull().such_columns.indexOf('Bank and cash accounts') >= 0), 'wrap-page-cash-flow': $route.path.indexOf('cash-flow') >= 0}">
    <div class="top-panel">
      <router-link :to="{name: 'Payment List'}" class="bread__link text-dark fw700 fz20" v-if="$route.path.indexOf('vessels') === -1 && $route.path.indexOf('payment/list/detail') >= 0">Payment List</router-link>
      <router-link :to="{name: 'Payment Instructions'}" class="bread__link text-dark fw700 fz20" v-if="$route.path.indexOf('vessels') === -1 && $route.path.indexOf('payment/instructions/detail') >= 0">Payment Instructions</router-link>
      <router-link :to="{name: 'Payment Calendar'}" class="bread__link text-dark fw700 fz20" v-if="$route.path.indexOf('vessels') === -1 && $route.path.indexOf('payment/calendar/detail') >= 0">Payment Calendar</router-link>
      <router-link :to="{name: 'CashFlow List'}" class="bread__link text-dark fw700 fz20 " v-if="$route.path.indexOf('vessels') === -1 && $route.path.indexOf('cashflow/detail') >= 0">Cash Flow List</router-link>
      <router-link :to="{name: 'CashFlow Diagram'}" class="bread__link text-dark fw700 fz20 " v-if="$route.path.indexOf('vessels') === -1 && $route.path.indexOf('cashflow/diagram/detail') >= 0">Cash Flow Projection</router-link>
      <router-link :to="{name: 'CashFlow Diagram New'}" class="bread__link text-dark fw700 fz20 " v-if="$route.path.indexOf('vessels') === -1 && $route.path.indexOf('cashflow/new-diagram/detail') >= 0">Cash Flow Diagram</router-link>

      <router-link :to="{name: 'Counterparties payments'}" class="bread__link text-dark fw700 fz20 " v-if="$route.path.indexOf('vessels') === -1 && $route.name === 'Counterparties Payment Detail'">Counterparties</router-link>
      <router-link :to="$route.path.indexOf('open/cash-flow') !== -1 ? {name: 'Vessel Cash-Flow'} : '../../'" class="bread__link text-dark fw700 fz20" v-if="$route.path.indexOf('vessels') !== -1 && getDataContractV !== null"><span class="fw700">{{getDataContractV.name}}: {{getFormDateDMY(getDataContractV.cp_date)}}</span></router-link>

      <svg class="bread__separator" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.29728 6.40332L5.18131 9.70563C4.91419 9.97749 4.48172 9.97703 4.21504 9.70422C3.94858 9.43145 3.94927 8.98957 4.21642 8.7175L6.84711 5.90934L4.21642 3.19208C3.9493 2.91997 3.94861 2.47838 4.21504 2.20557C4.34872 2.06881 4.52386 2.00043 4.69899 2.00043C4.87367 2.00043 5.04811 2.06835 5.18155 2.20416L8.29728 5.4154C8.42594 5.54611 8.49813 5.724 8.49813 5.90934C8.49813 6.09468 8.42573 6.27236 8.29728 6.40332Z" fill="#6A6A6A"/></svg>
      <router-link :to="{name: 'Accounting Invoice'}" class="bread__link text-dark fw700 fz20" v-if="$route.path.indexOf('open/accounting-invoice') !== -1">Vessels Accounting Invoices</router-link>
      <router-link :to="{name: 'Vessels CashFlow'}" class="bread__link text-dark fw700 fz20" v-if="$route.path.indexOf('open/cash-flow') !== -1">Vessels Cash Flow</router-link>

      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$route.path.indexOf('vessels') !== -1">
        <path d="M8.29924 6.40332L5.18326 9.70563C4.91614 9.97749 4.48367 9.97703 4.217 9.70422C3.95053 9.43145 3.95122 8.98957 4.21837 8.7175L6.84906 5.90934L4.21837 3.19208C3.95125 2.91997 3.95057 2.47838 4.217 2.20557C4.35068 2.06881 4.52581 2.00043 4.70094 2.00043C4.87562 2.00043 5.05006 2.06835 5.1835 2.20416L8.29924 5.4154C8.42789 5.54611 8.50009 5.724 8.50009 5.90934C8.50009 6.09468 8.42769 6.27236 8.29924 6.40332Z" fill="#6A6A6A"/>
      </svg>
      <span class="bread__link text-dark fw700 fz20" v-if="getInfoDetailPayment !== null">{{getInfoDetailPayment.payment_type === 'expense' ? ($route.path.indexOf('accounting-invoice') >= 0 ? 'Bill' : 'Payment') : ($route.path.indexOf('accounting-invoice') >= 0 ? 'Invoice' : 'Income')}}<span class="fw700 fz20 text-dark">{{getInfoDetailPayment.client ? ': ' + getInfoDetailPayment.client.company_name : ''}}</span></span>
      <span class="bread__link" v-if="getInfoDetailPayment === null"></span>
      <div class="block-buttons">
<!--        <p class="fz14 status not_paid" :class="{'rotate180': getInfoDetailPayment.payment_type === 'expense'}" v-if="getInfoDetailPayment.status === 'not_paid'  && getInfoDetailPayment.payment_type === 'expense' && $route.path.indexOf('accounting-invoice') === -1">-->
<!--           <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M2.43363 11H9.56637C10.79 11 11.4988 9.61376 10.7824 8.62176L7.21602 3.68372C6.61728 2.8547 5.38272 2.8547 4.78398 3.68372L1.21762 8.62176C0.501177 9.61375 1.20998 11 2.43363 11Z" fill="#9AA3B0"/>-->
<!--           </svg>-->
<!--          Not Paid-->
<!--        </p>-->
<!--        <p class="fz14 status not_paid-income" :class="{'rotate180': getInfoDetailPayment.payment_type === 'expense'}" v-if="getInfoDetailPayment.status === 'not_paid' && getInfoDetailPayment.payment_type !== 'expense' && $route.path.indexOf('accounting-invoice') === -1">-->
<!--           <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M2.43363 11H9.56637C10.79 11 11.4988 9.61376 10.7824 8.62176L7.21602 3.68372C6.61728 2.8547 5.38272 2.8547 4.78398 3.68372L1.21762 8.62176C0.501177 9.61375 1.20998 11 2.43363 11Z" fill="#9AA3B0"/>-->
<!--           </svg>-->
<!--          Not Paid-->
<!--        </p>-->
<!--        <p class="fz14 status in_progress" :class="{'rotate180': getInfoDetailPayment.payment_type === 'expense'}" v-if="getInfoDetailPayment.status === 'in_progress' && $route.path.indexOf('accounting-invoice') === -1">-->
<!--           <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M2.43363 11H9.56637C10.79 11 11.4988 9.61376 10.7824 8.62176L7.21602 3.68372C6.61728 2.8547 5.38272 2.8547 4.78398 3.68372L1.21762 8.62176C0.501177 9.61375 1.20998 11 2.43363 11Z" fill="#9AA3B0"/>-->
<!--           </svg>-->
<!--          On payment-->
<!--        </p>-->
<!--        <p class="fz14 status paid" :class="{'rotate180': getInfoDetailPayment.payment_type === 'expense'}" v-if="getInfoDetailPayment.status === 'paid' && $route.path.indexOf('accounting-invoice') === -1">-->
<!--           <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M2.43363 11H9.56637C10.79 11 11.4988 9.61376 10.7824 8.62176L7.21602 3.68372C6.61728 2.8547 5.38272 2.8547 4.78398 3.68372L1.21762 8.62176C0.501177 9.61375 1.20998 11 2.43363 11Z" fill="#9AA3B0"/>-->
<!--           </svg>-->
<!--          Paid-->
<!--        </p>-->
<!--        {{ getInfoDetailPayment.status }}-->
<!--        {{ getNextStatus(getInfoDetailPayment.status) }}-->
        <button :disabled="!($route.path.indexOf('accounting-invoice') === -1 && ((getPermissionEditPayment() === true && !getPermissionEditPaymentInStatusPaid()) || getPermissionChangeStatus()))" class="status-button fz14 fw500 text-white" :class="{'button-paid': getInfoDetailPayment.status === 'paid', 'button-in_progress': getInfoDetailPayment.status === 'in_progress',
        'button-not_paid-income': getInfoDetailPayment.status === 'not_paid'  && getInfoDetailPayment.payment_type !== 'expense', 'button-not_paid': getInfoDetailPayment.status === 'not_paid'  && getInfoDetailPayment.payment_type === 'expense'}"
        v-on:click="changeStatus(getNextStatus(getInfoDetailPayment.status))" v-if="$route.path.indexOf('accounting-invoice') === -1">{{getTextForStatus(getInfoDetailPayment.status)}}</button>
        <payment-detail-option-button v-if="!getPermissionEditPaymentInStatusPaid() && getPermissionEditPayment()" class="detail-button" :archivestatus="getInfoDetailPayment.is_archive" @emitChangeStatus="emitChangeStatus" @changeEmitArchivePayment="changeEmitArchivePayment" :key="keyRender" :status="getPrevStatus(getInfoDetailPayment.status)"></payment-detail-option-button>
      </div>
    </div>
    <div class="content-wrap" >
      <div>
        <p class="fz16 fw500 text-dark">About</p>
        <div class="date-block" v-if="getInfoDetailPayment.id">
          <p class="fz13 text-gray">ID</p>
          <p class="fz14 text-dark">#{{ getInfoDetailPayment.id }}</p>
        </div>

        <div class="date-block" v-if="$route.path.indexOf('accounting-invoice') === -1">
          <p class="fz13 text-gray">Type</p>
          <div class="block-button-type">
            <button class="fz13 fw500 text-dark" :class="{'active': getInfoDetailPayment.payment_type === 'expense'}" v-on:click="changePaymentData(getInfoDetailPayment.id, 'payment_type', 'text', 'expense', 'Type')">
              {{$route.path.indexOf('accounting-invoice') >= 0 ? 'Bill' : 'Payment'}}
            </button>
            <button class="fz13 fw500 text-dark" :class="{'active': getInfoDetailPayment.payment_type === 'income'}" v-on:click="changePaymentData(getInfoDetailPayment.id, 'payment_type', 'text', 'income', 'Type')">
              {{$route.path.indexOf('accounting-invoice') >= 0 ? 'Invoice' : 'Income'}}
            </button>
          </div>
        </div>
        <div class="date-block position-relative">
          <p class="fz13 text-gray">Counterparty</p>
<!--          <p class="fz14 text-dark" v-if="getInfoDetailPayment.client.company_name !== null && getInfoDetailPayment.client.company_name !== undefined">{{ getInfoDetailPayment.client.company_name }}</p>-->
<!--          {{getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()}}-->
          <button class="text-blue-dark button-show-add-counterparty fz13" v-on:click="showAddClient = true">Add new counterparty</button>
          <async-select
              :key="showAddClient"
              :searchInputActive="true"
              :searchInputText="getInfoDetailPayment.client_name"
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-model="getInfoDetailPayment.client"
              :allowEmpty="true"
              :closeOnSelect="true"
              label=""
              class="placeholderNone"
              url="/client/dropdown"
              :placeholder="''"
              :params="{ordering: 'company_name', is_archived: false}"
              watchKey="company_name"
              @changeTextSelectInput="changePaymentData(getInfoDetailPayment.id, 'client_name', 'text', $event, 'Counterparty text')"
              @on-select="changePaymentData(getInfoDetailPayment.id, 'client', 'object', getInfoDetailPayment.client, 'Counterparty')"
          ></async-select>
          <svg v-if="getInfoDetailPayment.client" class="counterparty-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4.5L5.84211 2M3 4.5L5.84211 7M3 4.5H13" stroke="#2C2C2C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13 11.5L10.1579 9M13 11.5L10.1579 14M13 11.5H3" stroke="#9AA3B0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <div class="date-block position-relative">
          <p class="fz13 text-gray">Payment Amount</p>
          <input-format-number v-model="getInfoDetailPayment.payment_amount" :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()" @blur="changePaymentData(getInfoDetailPayment.id, 'payment_amount', 'number', getInfoDetailPayment.payment_amount, 'Payment Amount')"></input-format-number>
<!--          <input :disabled="getPermissionEditPaymentInStatusPaid()" class="input-with-text" type="text" v-model="getInfoDetailPayment.payment_amount" @input="getInfoDetailPayment.payment_amount = checkNum(getInfoDetailPayment.payment_amount)" @focusout="changePaymentData(getInfoDetailPayment.id, 'payment_amount', 'number', getInfoDetailPayment.payment_amount, 'Payment Amount')">-->
          <counterparties-drop
              class="valute-drop-currency"
              title=""
              :list="getValutaList"
              :removeSelectItemBeforeClick="false"
              :activeItem="{name: getInfoDetailPayment.currency, id: getInfoDetailPayment.currency}"
              :placeholder="''"
              :is-disabled="getBoolDontSelect(getInfoDetailPayment) || (getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment())"
              @select="changeCurrency"
              @afterClose="changePaymentData(getInfoDetailPayment.id, 'currency', 'text', getInfoDetailPayment.currency, 'Currency')"
          ></counterparties-drop>
          <!--          <p class="fz14 text-dark">{{getInfoDetailPayment.payment_amount | formatNumberTwo}} {{getInfoDetailPayment.currency}} <span class="fz14 text-gray">({{getInfoDetailPayment.currency_amount | formatNumberTwo}} USD)</span></p>-->
        </div>
        <div class="date-block position-relative">
          <p class="fz13 text-gray">Converted Amount in USD</p>
          <input-format-number v-model="getInfoDetailPayment.currency_amount" :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()" @blur="changePaymentData(getInfoDetailPayment.id, 'currency_amount', 'number', getInfoDetailPayment.currency_amount, 'Converted Amount')"></input-format-number>

<!--          <input class="input-with-text" :disabled="getPermissionEditPaymentInStatusPaid()" type="text" v-model="getInfoDetailPayment.currency_amount" @input="getInfoDetailPayment.currency_amount = checkNum(getInfoDetailPayment.currency_amount)" @focusout="changePaymentData(getInfoDetailPayment.id, 'currency_amount', 'number', getInfoDetailPayment.currency_amount, 'Converted Amount')">-->
          <!--          <p class="fz14 text-dark">{{getInfoDetailPayment.payment_amount | formatNumberTwo}} {{getInfoDetailPayment.currency}} <span class="fz14 text-gray">({{getInfoDetailPayment.currency_amount | formatNumberTwo}} USD)</span></p>-->
        </div>
        <div class="date-block">
          <p class="fz13 text-gray">Due Date</p>
          <date-picker
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              value-type="date"
              class="datepicker-due-date"
              v-model="getInfoDetailPayment.execute_date"
              format="DD.MM.YYYY"
              @change="changePaymentData(getInfoDetailPayment.id, 'execute_date', 'date', getInfoDetailPayment.execute_date, 'Due Date')"
              type="date"
              ref="datePickDue"
          >
          </date-picker>
        </div>
        <div class="date-block">
          <p class="fz13 text-gray">Reference</p>
          <async-select
              class="h36-async"
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-model="getInfoDetailPayment.account"
              :allowEmpty="true"
              label=""
              :closeOnSelect="true"
              :is-multiple="false"
              :beforeWatchKey="getPermissionShowDopInfoAcc() ? 'account_id' : null"
              url="/payment/account"
              :placeholder="''"
              :params="{is_archive: false}"
              @on-select="changePaymentData(getInfoDetailPayment.id, 'account', 'object', getInfoDetailPayment.account, 'Reference')"
              @changeTextSelectInput="changePaymentData(getInfoDetailPayment.id, 'account_name', 'text', $event, 'Reference text')"
              :searchInputActive="true"
              :searchInputText="getInfoDetailPayment.account_name"
          ></async-select>
        </div>
        <div class="date-block">
          <p class="fz13 text-gray">Additionally</p>
          <input type="text" maxlength="15" v-model="getInfoDetailPayment.additionally" @input="getInfoDetailPayment.additionally = getInfoDetailPayment.additionally.toUpperCase()" @blur="changePaymentData(getInfoDetailPayment.id, 'additionally', 'text', getInfoDetailPayment.additionally, 'Additionally')">
        </div>

<!--        <div class="date-block" v-if="getAccountName().length !== 0">-->
<!--          <p class="fz13 text-gray">Account name</p>-->
<!--&lt;!&ndash;          <p class="fz14 text-dark" v-html="getAccountName()"></p>&ndash;&gt;-->
<!--          <async-select-->
<!--              v-tooltip.top="getTextAccountTitle(getInfoDetailPayment.account)"-->
<!--              class="select-list-payment"-->
<!--              v-model="getInfoDetailPayment.account"-->
<!--              :allowEmpty="true"-->
<!--              label=""-->
<!--              :is-multiple="true"-->
<!--              :beforeWatchKey="'account_id'"-->
<!--              url="/payment/account"-->
<!--              :placeholder="''"-->
<!--              :params="{is_archive: false}"-->
<!--              :isMultiple="true"-->
<!--              @on-select="changePaymentData(getInfoDetailPayment.id, 'account', 'array', getInfoDetailPayment.account, 'Reference')"-->
<!--          ></async-select>-->
<!--        </div>-->
        <div class="date-block" v-if="$route.path.indexOf('accounting-invoice') === -1 && !(getPermissionShowDopColumnsFull().has_permission && getPermissionShowDopColumnsFull().such_columns.indexOf('Real Account') >= 0)">
          <p class="fz13 text-gray">Real Account</p>
<!--          <p class="fz14 text-dark" v-if="getInfoDetailPayment.real_account !== null && getInfoDetailPayment.real_account !== undefined">{{getInfoDetailPayment.real_account.company_name}}</p>-->
          <async-select
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-tooltip.top="getInfoDetailPayment.real_account !== null && getInfoDetailPayment.real_account ? getInfoDetailPayment.real_account.company_name : ''"
              class="select-list-payment"
              v-model="getInfoDetailPayment.real_account"
              :allowEmpty="true"
              :closeOnSelect="true"
              label=""
              url="/client/dropdown"
              :placeholder="''"
              :params="{ordering: 'company_name', is_archived: false}"
              watchKey="company_name"
              @on-select="changePaymentData(getInfoDetailPayment.id, 'real_account', 'object', getInfoDetailPayment.real_account, 'Real Account')"
          ></async-select>
        </div>
        <div class="date-block" v-if="getPermissionShowVesselAndCpDate()">
          <p class="fz13 text-gray">Vessel, CP Date</p>
<!--          <p class="fz14 text-dark">{{getInfoDetailPayment.ship.name}}</p>-->
          <async-select
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-tooltip.top="getInfoDetailPayment.ship ? (getInfoDetailPayment.ship.cp_date ? ( getInfoDetailPayment.ship.name + ' (' +getInfoDetailPayment. ship.cp_date + ')' ): getInfoDetailPayment.ship.name) : ''"
              class="select-list-payment"
              :id="'sd238472839482sd22'"
              label=""
              url="/contract/dropdown"
              :afterWatchKey="'cp_date'"
              :params="{is_archive: false, contract_type: ['SHIP']}"
              :allowEmpty="true"
              :placeholder="''"
              :closeOnSelect="true"
              v-model="getInfoDetailPayment.ship"
              :after-watch-key-brackets="'cp_date'"
              @on-select="changePaymentData(getInfoDetailPayment.id, 'ship', 'ship', getInfoDetailPayment.ship, 'Vessel, CP Date')"
          />
        </div>
        <div class="date-block" v-if="!(getPermissionShowDopColumnsFull().has_permission && getPermissionShowDopColumnsFull().such_columns.indexOf('Settled Vsl') >= 0)">
          <p class="fz13 text-gray">Settled Vessel</p>
<!--          <p class="fz14 text-dark">{{getInfoDetailPayment.settled_ship.name}}</p>-->
          <async-select
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-tooltip.top="getInfoDetailPayment.settled_ship ? (getInfoDetailPayment.settled_ship.name + ' (' + getFormatDate(getInfoDetailPayment.settled_ship.cp_date) + ')') : ''"
              class="select-list-payment"
              placeholder=""
              :id="'sd211s44d22'"
              label=""
              url="/contract/dropdown"
              :after-watch-key="'cp_date'"
              :after-watch-key-brackets="'cp_date'"
              :params="{is_archive: false, contract_type: ['SHIP'], ordering: 'name'}"
              :allowEmpty="true"
              :closeOnSelect="true"
              v-model="getInfoDetailPayment.settled_ship"
              @on-select="changePaymentData(getInfoDetailPayment.id, 'settled_ship', 'object', getInfoDetailPayment.settled_ship, 'Settled Ship')"
          />
        </div>
        <div class="date-block">
          <p class="fz13 text-gray">Disbursements (Port)</p>
          <async-select
              :afterWatchKeyBrackets="'country'"
              :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-tooltip.top="getTextFromPorts(getInfoDetailPayment.ports)"
              class="select-list-payment"
              :is-multiple="false"
              v-model="getInfoDetailPayment.ports"
              :allowEmpty="true"
              label=""
              url="/port/dropdown"
              :placeholder="''"
              :closeOnSelect="true"
              :params="{is_archived: false}"
              @on-select="changePaymentData(getInfoDetailPayment.id, 'ports', 'object', getInfoDetailPayment.ports, 'Disbursements')"
          ></async-select>
<!--          <p class="fz14 text-dark" v-html="getTextFromPorts(getInfoDetailPayment.ports)"></p>-->
        </div>
        <div class="date-block" v-if="$route.path.indexOf('accounting-invoice') === -1 && !(getPermissionShowDopColumnsFull().has_permission && getPermissionShowDopColumnsFull().such_columns.indexOf('Statement member') >= 0)">
          <p class="fz13 text-gray" v-on:click="testCpDatesListAfterDelete">Statement Member</p>
          <counterparties-drop
              :formatCpDate="true"
              :is-disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()"
              v-if="$route.name !== 'Accounting Invoice'"
              title=""
              :placeholder="''"
              :list="getCPDateListStatement"
              :active-item="{name: getInfoDetailPayment.statement_member, id: getInfoDetailPayment.statement_member}"
              @select="selectCPDateStatement"
              :dont-select="true"
              @close="changePaymentData(getInfoDetailPayment.id, 'statement_member', 'text', getInfoDetailPayment.statement_member, 'Statement Member')"
          ></counterparties-drop>
        </div>
<!--        <div class="date-block">-->
<!--          <p class="fz13 text-gray">CP Date</p>-->
<!--          <p class="fz14 text-dark" v-if="getInfoDetailPayment.cp_date !== null">{{getFormDateForTime(getInfoDetailPayment.cp_date)}}</p>-->
<!--        </div>-->
        <div class="date-block">
          <p class="fz13 text-gray" v-tooltip.top="'3434'">Remarks</p>
<!--          <pre>{{ getInfoDetailPayment }}</pre>-->
          <textarea :disabled="getPermissionEditPaymentInStatusPaid() || !getPermissionEditPayment()" class="textarea-remark" v-model="getInfoDetailPayment.comment" @focusout="changePaymentData(getInfoDetailPayment.id, 'comment', 'text',getInfoDetailPayment.comment, 'Remark')"></textarea>
<!--          <div class="user-block" v-if="getInfoDetailPayment.comment_creator !== null">-->
<!--            <img v-if="getInfoDetailPayment.comment_creator.avatar !== null" :src="getInfoDetailPayment.comment_creator.avatar" class="img-profile" alt="">-->
<!--            <svg v-if="getInfoDetailPayment.comment_creator.avatar === null" class="img-profile" width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <circle cx="80" cy="80" r="80" fill="white"/>-->
<!--              <path d="M80 0.00305176C35.8218 0.00305176 0 35.8179 0 79.9995C0 124.181 35.8183 159.996 80 159.996C124.185 159.996 160 124.181 160 79.9995C160 35.8179 124.185 0.00305176 80 0.00305176ZM80 23.9229C94.6183 23.9229 106.464 35.7722 106.464 50.3834C106.464 64.9982 94.6183 76.844 80 76.844C65.3887 76.844 53.543 64.9982 53.543 50.3834C53.543 35.7722 65.3887 23.9229 80 23.9229ZM79.9824 139.081C65.4028 139.081 52.0495 133.771 41.75 124.982C39.241 122.842 37.7932 119.704 37.7932 116.412C37.7932 101.593 49.7865 89.7334 64.6086 89.7334H95.3984C110.224 89.7334 122.172 101.593 122.172 116.412C122.172 119.708 120.731 122.839 118.218 124.979C107.922 133.771 94.5656 139.081 79.9824 139.081Z" fill="#DEE3EA"/>-->
<!--            </svg>-->
<!--            <p class="fz13 fw500">{{getInfoDetailPayment.comment_creator.first_name}} {{getInfoDetailPayment.comment_creator.last_name}}</p>-->
<!--          </div>-->
<!--          <p class="comment fz14 text-dark" v-if="getInfoDetailPayment.comment.length">{{getInfoDetailPayment.comment}}</p>-->
        </div>
<!--        <div class="date-block" v-if="getInfoDetailPayment.files.length">-->
<!--          <p class="fz13 text-gray">Attachments</p>-->
<!--        </div>-->
        <payment-detail-atachements-file
            :add-file-permission="getPermissionForAddFile() && (!getPermissionEditPaymentInStatusPaid() && getPermissionEditPayment())"
            :edit-permission="(getPermissionEditPayment() || getPermissionEditAndRemoveFile()) && (!getPermissionEditPaymentInStatusPaid() || getPermissionEditPayment())"
            v-if="getInfoDetailPayment !== null"
            ref="fileNormal"
            class="file-attachments"
            :class-for-title="'fz13 text-gray mt12'"
            :file-props="getInfoDetailPayment.files"
            :visible-add-file="true"
            :await-delete-file="true"
            @addFile="emitAddFile"
            @emitBeforeDeleteFileFillFile="openModalDeleteFile"
            @fileDeleted="renderNew"
            @changeParentId="setParentsIDForFile"
            :deleteFilePermission="getPermissionDeleteFile() && (!getPermissionEditPaymentInStatusPaid() && getPermissionEditPayment())"
            :disabled-add-new-folder="loadAddFolder1"
        >
        </payment-detail-atachements-file>
      </div>
      <div @mousemove="mousePointer" v-if="!(getPermissionShowDopColumnsFull().has_permission && getPermissionShowDopColumnsFull().such_columns.indexOf('Bank and cash accounts') >= 0)">
        <p class="fz16 fw500 text-dark" v-if="!getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()">Bank and Cash Accounts</p>
<!--        <payment-drop-bank-and-cash-->
<!--            :key="keyRenderClient"-->
<!--            :is-disabled="!getPermissionEditPayment() || getPermissionEditPaymentInStatusPaid()"-->
<!--            class="dropdown"-->
<!--            title="Bank and Cash Accounts"-->
<!--            :list="getPaymentsCash"-->
<!--            :active-item="cashDefaultActive"-->
<!--            @select="setActiveBankAccount"-->
<!--        ></payment-drop-bank-and-cash>-->
        <bank-and-cash-select
            v-if="!getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()"
            :isMultiple="false"
            :disabled="!getPermissionEditPayment() || getPermissionEditPaymentInStatusPaid()"
            class="select-list-payment"
            :key="'sd33l3l2l2323klklg'"
            :placeholder="''"
            label=""
            :closeOnSelect="true"
            :allow-empty="true"
            :selected-requisites="getInfoDetailPayment.bank"
            :selected-banks="getInfoDetailPayment.cash"
            @onSetBank="setCash"
            @onSetRequisite="setBank"
        ></bank-and-cash-select>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.cash !== null && getInfoDetailPayment.cash && getInfoDetailPayment.cash.currency && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" @mouseenter="mousePointer" v-on:click="copyText(getInfoDetailPayment.cash.currency)">
          <p class="fz13 text-gray">Currency</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.cash.currency}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.cash.currency)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.account_number && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.account_number)">
          <p class="fz13 text-gray">Account Number</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.account_number}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.account_number)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.iban && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.iban)">
          <p class="fz13 text-gray">IBAN</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.iban}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.iban)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.description && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.description)">
          <p class="fz13 text-gray">Description</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.description}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.description)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.bank && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.bank)">
          <p class="fz13 text-gray">Bank</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.bank}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.bank)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.clearing_number && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.clearing_number)">
          <p class="fz13 text-gray">Clearing number</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.clearing_number}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.clearing_number)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.bic && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.bic)">
          <p class="fz13 text-gray">BIC/SWIFT</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.bic}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.bic)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && getInfoDetailPayment.bank.currency && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.currency)">
          <p class="fz13 text-gray">Currency</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.currency}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.currency)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
        <div class="date-block copy-block" v-if="getInfoDetailPayment.bank !== null && getInfoDetailPayment.bank && (getInfoDetailPayment.bank.account.id || getInfoDetailPayment.bank.account.name) && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()" v-on:click="copyText(getInfoDetailPayment.bank.account.id + ': ' + getInfoDetailPayment.bank.account.name)">
          <p class="fz13 text-gray">Account name</p>
          <p class="fz14 text-dark">{{getInfoDetailPayment.bank.account.id}}: {{getInfoDetailPayment.bank.account.name}}</p>
          <div class="bg-block" v-on:click="copyText(getInfoDetailPayment.bank.account.id + ': ' + getInfoDetailPayment.bank.account.name)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.1719C5 9.13178 5.85439 8.28861 6.90834 8.28861H13.9456C14.9996 8.28861 15.854 9.13178 15.854 10.1719V17.1167C15.854 18.1568 14.9996 19 13.9456 19H6.90834C5.85439 19 5 18.1568 5 17.1167V10.1719ZM6.90834 9.60405C6.59056 9.60405 6.33294 9.85828 6.33294 10.1719V17.1167C6.33294 17.4303 6.59056 17.6846 6.90834 17.6846H13.9456C14.2634 17.6846 14.521 17.4303 14.521 17.1167V10.1719C14.521 9.85828 14.2634 9.60405 13.9456 9.60405H6.90834Z" fill="#2C2C2C"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14605 6.88328C8.14605 5.84317 9.00044 5 10.0544 5H17.0917C18.1456 5 19 5.84317 19 6.88328V13.8281C19 14.8682 18.1456 15.7114 17.0917 15.7114C16.7236 15.7114 16.4252 15.4169 16.4252 15.0537C16.4252 14.6904 16.7236 14.396 17.0917 14.396C17.4094 14.396 17.6671 14.1417 17.6671 13.8281V6.88328C17.6671 6.56967 17.4094 6.31543 17.0917 6.31543H10.0544C9.73661 6.31543 9.47899 6.56967 9.47899 6.88328C9.47899 7.24652 9.1806 7.54099 8.81252 7.54099C8.44444 7.54099 8.14605 7.24652 8.14605 6.88328Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>

        <linked-wrap
            v-if="(!getPermissionEditPaymentInStatusPaid() || getPermissionEditPayment()) && !getPermissionHideLinkedOperation() && !getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()"
          class="block-input linked-wrap"
          :linkedPayments="getInfoDetailPayment.linked_payments" 
          :linkedInvoices="getInfoDetailPayment.linked_invoices" 
          :linkedOwners="getInfoDetailPayment.linked_owners" 
          linkedType="Payments"
          @on-change="onChangeLinked"
        />
        <div class="hide-block-bank" v-if="getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid()">
          <svg width="125" height="92" viewBox="0 0 125 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M98.9223 22.2096L99.3695 21.3152L98.9223 22.2096ZM62.4098 3.95333L62.857 3.05891V3.05891L62.4098 3.95333ZM60.5965 3.96575L61.0559 4.85397V4.85397L60.5965 3.96575ZM25.3011 22.222L24.8417 21.3338L25.3011 22.222ZM100.5 74.9984C101.052 74.9984 101.5 74.5507 101.5 73.9984C101.5 73.4462 101.052 72.9984 100.5 72.9984V74.9984ZM93.5 32.4984C93.5 31.9462 93.0523 31.4984 92.5 31.4984C91.9477 31.4984 91.5 31.9462 91.5 32.4984H93.5ZM24 72.9984C23.4477 72.9984 23 73.4462 23 73.9984C23 74.5507 23.4477 74.9984 24 74.9984V72.9984ZM33 32.4984C33 31.9462 32.5523 31.4984 32 31.4984C31.4477 31.4984 31 31.9462 31 32.4984H33ZM36 66.4984C36 67.0507 36.4477 67.4984 37 67.4984C37.5523 67.4984 38 67.0507 38 66.4984H36ZM88 32.4984C88 31.9462 87.5523 31.4984 87 31.4984C86.4477 31.4984 86 31.9462 86 32.4984H88ZM86 66.4984C86 67.0507 86.4477 67.4984 87 67.4984C87.5523 67.4984 88 67.0507 88 66.4984H86ZM14 79.9984C13.4477 79.9984 13 80.4462 13 80.9984C13 81.5507 13.4477 81.9984 14 81.9984V79.9984ZM110.5 81.9984C111.052 81.9984 111.5 81.5507 111.5 80.9984C111.5 80.4462 111.052 79.9984 110.5 79.9984V81.9984ZM3 86.9984C2.44772 86.9984 2 87.4462 2 87.9984C2 88.5507 2.44772 88.9984 3 88.9984V86.9984ZM121.5 88.9984C122.052 88.9984 122.5 88.5507 122.5 87.9984C122.5 87.4462 122.052 86.9984 121.5 86.9984V88.9984ZM62.5 48.4984L62.4311 49.4961L62.5 48.4984ZM68.2895 42.1447C68.4402 42.6761 68.993 42.9846 69.5244 42.834C70.0557 42.6833 70.3643 42.1304 70.2136 41.5991L68.2895 42.1447ZM56.684 54.7553C56.543 54.2213 55.9958 53.9027 55.4618 54.0437C54.9278 54.1847 54.6093 54.7319 54.7503 55.2659L56.684 54.7553ZM63.5 33.9984C63.5 33.4462 63.0523 32.9984 62.5 32.9984C61.9477 32.9984 61.5 33.4462 61.5 33.9984H63.5ZM61.5 62.9984C61.5 63.5507 61.9477 63.9984 62.5 63.9984C63.0523 63.9984 63.5 63.5507 63.5 62.9984H61.5ZM99.3695 21.3152L62.857 3.05891L61.9626 4.84776L98.4751 23.104L99.3695 21.3152ZM60.1371 3.07753L24.8417 21.3338L25.7605 23.1102L61.0559 4.85397L60.1371 3.07753ZM92.5 74.9984H100.5V72.9984H92.5V74.9984ZM93.5 73.9984V32.4984H91.5V73.9984H93.5ZM24 74.9984H32V72.9984H24V74.9984ZM32 74.9984H92.5V72.9984H32V74.9984ZM33 73.9984V32.4984H31V73.9984H33ZM26.22 26.9984H37V24.9984H26.22V26.9984ZM37 26.9984H98.0279V24.9984H37V26.9984ZM36 25.9984V66.4984H38V25.9984H36ZM86 32.4984V66.4984H88V32.4984H86ZM14 81.9984H110.5V79.9984H14V81.9984ZM3 88.9984H121.5V86.9984H3V88.9984ZM62.857 3.05891C61.9995 2.63014 60.9887 2.63706 60.1371 3.07754L61.0559 4.85397C61.3398 4.70715 61.6767 4.70484 61.9626 4.84776L62.857 3.05891ZM98.4751 23.104C99.4189 23.5759 99.0831 24.9984 98.0279 24.9984V26.9984C101.194 26.9984 102.201 22.7309 99.3695 21.3152L98.4751 23.104ZM24.8417 21.3338C22.0496 22.778 23.0765 26.9984 26.22 26.9984V24.9984C25.1721 24.9984 24.8298 23.5916 25.7605 23.1102L24.8417 21.3338ZM56.5 42.6984C56.5 41.0694 57.1439 39.9164 58.1569 39.1434C59.2024 38.3456 60.7187 37.8984 62.5 37.8984V35.8984C60.4153 35.8984 58.4316 36.418 56.9436 37.5535C55.4231 38.7138 54.5 40.4608 54.5 42.6984H56.5ZM68.5 54.2984C68.5 55.8545 67.8621 57.0142 66.8367 57.8098C65.7852 58.6257 64.2673 59.0984 62.5 59.0984V61.0984C64.5986 61.0984 66.5808 60.5398 68.0628 59.3899C69.5709 58.2198 70.5 56.4795 70.5 54.2984H68.5ZM70.5 54.2984C70.5 53.1137 70.0769 51.5123 68.8414 50.1474C67.5886 48.7634 65.5798 47.7087 62.5689 47.5008L62.4311 49.4961C65.0202 49.6748 66.5114 50.5535 67.3586 51.4895C68.2231 52.4445 68.5 53.5498 68.5 54.2984H70.5ZM62.5689 47.5008C59.9369 47.3191 58.4523 46.5373 57.6232 45.6691C56.7933 44.8 56.5 43.7184 56.5 42.6984H54.5C54.5 44.0951 54.9067 45.7202 56.1768 47.0503C57.4477 48.3812 59.4631 49.2911 62.4311 49.4961L62.5689 47.5008ZM62.5 37.8984C65.2851 37.8984 67.6008 39.7162 68.2895 42.1447L70.2136 41.5991C69.2763 38.2939 66.1625 35.8984 62.5 35.8984V37.8984ZM62.5 59.0984C59.6777 59.0984 57.3381 57.2321 56.684 54.7553L54.7503 55.2659C55.6411 58.6392 58.7893 61.0984 62.5 61.0984V59.0984ZM63.5 36.8984V33.9984H61.5V36.8984H63.5ZM61.5 60.0984V62.9984H63.5V60.0984H61.5Z" fill="#DEE3EA"/>
          </svg>
          <p class="fz16 fw500">Bank and cash accounts information is not available</p>
        </div>
      </div>
      <div v-if="!getPermissionHideReportInStatusNotPaid()" class="block-reports" @dragenter="dragEnter" :class="{'pr': dragMode}" v-on:mouseout="dragEnd" @drop="dragEnd">
        <p class="fz16 fw500 text-dark">Report</p>
        <p class="fz14 text-dark mt14" v-if="$route.path.indexOf('accounting-invoice') === -1 && (!getPermissionEditPaymentInStatusPaid() || getPermissionEditPayment())">Fill out the report to close the payment. Attach payment receipts, add a comment if required.</p>
        <p class="fz13 text-gray mt14">Paid Date</p>
        <date-picker
            :disabled="!getPermissionChangePaidDate()"
            value-type="date"
            class="datepick paid_date"
            :class="{'errorDate': errorDate}"
            v-model="date"
            format="DD.MM.YYYY"
            @change="setDateReceipt"
        ></date-picker>
<!--        :disabled-date="disabledRange">-->

        <p class="fz13 text-gray" v-if="$route.path.indexOf('accounting-invoice') === -1">Bank Receipt</p>
        <div class="block-drag-and-drops" :class="{'errorFiles': errorFiles}" v-if=" $route.path.indexOf('accounting-invoice') === -1 && (getPermissionEditPayment()===true || getPermissionForAddFile() === true) && !getPermissionEditPaymentInStatusPaid() && !getPermissionBlockChangePaidDateAndBankReceipt()">
          <div class="drag-zone" :class="{'dragMode': dragMode}">
            <svg width="157" height="97" viewBox="0 0 157 97" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.33496 93L6.43262 90.334H2.67285L1.77051 93H0.177734L3.73926 83.1357H5.39355L8.95508 93H7.33496ZM4.53223 84.7764L3.0625 89.1035H6.04297L4.57324 84.7764H4.53223ZM9.89844 84.1064H11.3818V85.8086H12.749V86.9775H11.3818V90.9424C11.3818 91.2523 11.4525 91.4801 11.5938 91.626C11.735 91.7718 11.9561 91.8447 12.2568 91.8447C12.4756 91.8447 12.6374 91.8333 12.7422 91.8105V92.9795C12.5599 93.0251 12.2865 93.0479 11.9219 93.0479C11.1973 93.0479 10.6777 92.8997 10.3633 92.6035C10.0534 92.3027 9.89844 91.8037 9.89844 91.1064V86.9775H8.85254V85.8086H9.89844V84.1064ZM14.3965 84.1064H15.8799V85.8086H17.2471V86.9775H15.8799V90.9424C15.8799 91.2523 15.9505 91.4801 16.0918 91.626C16.2331 91.7718 16.4541 91.8447 16.7549 91.8447C16.9736 91.8447 17.1354 91.8333 17.2402 91.8105V92.9795C17.0579 93.0251 16.7845 93.0479 16.4199 93.0479C15.6953 93.0479 15.1758 92.8997 14.8613 92.6035C14.5514 92.3027 14.3965 91.8037 14.3965 91.1064V86.9775H13.3506V85.8086H14.3965V84.1064ZM20.8701 91.9541C21.3896 91.9541 21.8249 91.7969 22.1758 91.4824C22.5312 91.1634 22.709 90.7715 22.709 90.3066V89.7393L20.9385 89.8486C20.4964 89.8805 20.1546 89.9899 19.9131 90.1768C19.6761 90.359 19.5576 90.6051 19.5576 90.915C19.5576 91.2295 19.6761 91.4824 19.9131 91.6738C20.1546 91.8607 20.4736 91.9541 20.8701 91.9541ZM20.46 93.123C19.7536 93.123 19.1771 92.9225 18.7305 92.5215C18.2884 92.1204 18.0674 91.5986 18.0674 90.9561C18.0674 90.3271 18.2998 89.8281 18.7646 89.459C19.2295 89.0853 19.888 88.8757 20.7402 88.8301L22.709 88.7139V88.1602C22.709 87.7591 22.5814 87.4469 22.3262 87.2236C22.071 86.9958 21.7178 86.8818 21.2666 86.8818C20.8473 86.8818 20.5055 86.9753 20.2412 87.1621C19.9814 87.349 19.8174 87.6064 19.749 87.9346H18.3545C18.3955 87.2692 18.6826 86.7269 19.2158 86.3076C19.749 85.8883 20.4508 85.6787 21.3213 85.6787C22.1917 85.6787 22.8844 85.8929 23.3994 86.3213C23.9189 86.7497 24.1787 87.3239 24.1787 88.0439V93H22.7637V91.8174H22.7295C22.5244 92.2139 22.2122 92.5306 21.793 92.7676C21.3783 93.0046 20.9339 93.123 20.46 93.123ZM31.7871 88.2832H30.3789C30.3014 87.8776 30.1146 87.5472 29.8184 87.292C29.5267 87.0368 29.1507 86.9092 28.6904 86.9092C28.1162 86.9092 27.6559 87.1348 27.3096 87.5859C26.9678 88.0326 26.7969 88.6387 26.7969 89.4043C26.7969 90.1836 26.9678 90.7943 27.3096 91.2363C27.6559 91.6784 28.1208 91.8994 28.7041 91.8994C29.1553 91.8994 29.5244 91.7832 29.8115 91.5508C30.1032 91.3138 30.2923 90.9857 30.3789 90.5664H31.8008C31.7233 91.3366 31.3997 91.9587 30.8301 92.4326C30.265 92.902 29.5518 93.1367 28.6904 93.1367C27.6559 93.1367 26.8311 92.804 26.2158 92.1387C25.6006 91.4688 25.293 90.5573 25.293 89.4043C25.293 88.265 25.6006 87.3604 26.2158 86.6904C26.8311 86.016 27.6514 85.6787 28.6768 85.6787C29.57 85.6787 30.2946 85.9294 30.8506 86.4307C31.4066 86.9274 31.7188 87.5449 31.7871 88.2832ZM32.9014 93V83.1357H34.3643V87.0117H34.3984C34.599 86.5879 34.8929 86.262 35.2803 86.0342C35.6676 85.8018 36.1325 85.6855 36.6748 85.6855C37.4587 85.6855 38.0739 85.9271 38.5205 86.4102C38.9717 86.8932 39.1973 87.5449 39.1973 88.3652V93H37.7139V88.6523C37.7139 88.1146 37.5794 87.6976 37.3105 87.4014C37.0462 87.1051 36.6566 86.957 36.1416 86.957C35.5993 86.957 35.1686 87.1302 34.8496 87.4766C34.5352 87.8184 34.3779 88.2741 34.3779 88.8438V93H32.9014ZM43.9004 93V86.9775H42.9092V85.8223H43.9004V85.1182C43.9004 84.4163 44.0713 83.8991 44.4131 83.5664C44.7549 83.2337 45.2904 83.0674 46.0195 83.0674C46.3158 83.0674 46.5915 83.0902 46.8467 83.1357V84.2295C46.7008 84.2021 46.5208 84.1885 46.3066 84.1885C45.6777 84.1885 45.3633 84.5075 45.3633 85.1455V85.8223H46.8193V86.9775H45.3838V93H43.9004ZM48.0293 93V85.8086H49.5059V93H48.0293ZM49.376 84.5098C49.2074 84.6738 49.0046 84.7559 48.7676 84.7559C48.5306 84.7559 48.3278 84.6738 48.1592 84.5098C47.9951 84.3457 47.9131 84.1475 47.9131 83.915C47.9131 83.6781 47.9951 83.4775 48.1592 83.3135C48.3278 83.1494 48.5306 83.0674 48.7676 83.0674C49.0091 83.0674 49.2119 83.1494 49.376 83.3135C49.5446 83.4775 49.6289 83.6781 49.6289 83.915C49.6289 84.1475 49.5446 84.3457 49.376 84.5098ZM51.0713 93V83.1357H52.5479V93H51.0713ZM58.3242 87.3877C58.0007 87.0413 57.5837 86.8682 57.0732 86.8682C56.5628 86.8682 56.139 87.0436 55.8018 87.3945C55.4645 87.7409 55.2777 88.1898 55.2412 88.7412H58.8369C58.8187 88.1852 58.6478 87.734 58.3242 87.3877ZM58.8301 90.8877H60.2314C60.1266 91.5485 59.7894 92.0885 59.2197 92.5078C58.6501 92.9271 57.9551 93.1367 57.1348 93.1367C56.082 93.1367 55.2526 92.8063 54.6465 92.1455C54.0449 91.4801 53.7441 90.5778 53.7441 89.4385C53.7441 88.3083 54.0449 87.3991 54.6465 86.7109C55.2526 86.0228 56.0615 85.6787 57.0732 85.6787C58.0667 85.6787 58.8551 86.0046 59.4385 86.6562C60.0218 87.3034 60.3135 88.1738 60.3135 89.2676V89.7734H55.2344V89.8623C55.2344 90.4912 55.4098 90.9948 55.7607 91.373C56.1117 91.7513 56.5811 91.9404 57.1689 91.9404C57.5837 91.9404 57.9391 91.8447 58.2354 91.6533C58.5316 91.4619 58.7298 91.2067 58.8301 90.8877ZM64.7363 84.1064H66.2197V85.8086H67.5869V86.9775H66.2197V90.9424C66.2197 91.2523 66.2904 91.4801 66.4316 91.626C66.5729 91.7718 66.7939 91.8447 67.0947 91.8447C67.3135 91.8447 67.4753 91.8333 67.5801 91.8105V92.9795C67.3978 93.0251 67.1243 93.0479 66.7598 93.0479C66.0352 93.0479 65.5156 92.8997 65.2012 92.6035C64.8913 92.3027 64.7363 91.8037 64.7363 91.1064V86.9775H63.6904V85.8086H64.7363V84.1064ZM74.1973 92.1387C73.5775 92.804 72.7503 93.1367 71.7158 93.1367C70.6813 93.1367 69.8542 92.804 69.2344 92.1387C68.6146 91.4688 68.3047 90.5573 68.3047 89.4043C68.3047 88.2559 68.6146 87.349 69.2344 86.6836C69.8542 86.0137 70.6813 85.6787 71.7158 85.6787C72.7503 85.6787 73.5775 86.0137 74.1973 86.6836C74.8171 87.349 75.127 88.2559 75.127 89.4043C75.127 90.5573 74.8171 91.4688 74.1973 92.1387ZM71.7158 91.9199C72.3037 91.9199 72.7686 91.6989 73.1104 91.2568C73.4521 90.8148 73.623 90.1973 73.623 89.4043C73.623 88.6159 73.4499 88.0007 73.1035 87.5586C72.7617 87.1165 72.2992 86.8955 71.7158 86.8955C71.1325 86.8955 70.6676 87.1165 70.3213 87.5586C69.9795 88.0007 69.8086 88.6159 69.8086 89.4043C69.8086 90.1973 69.9795 90.8148 70.3213 91.2568C70.6676 91.6989 71.1325 91.9199 71.7158 91.9199ZM79.543 84.1064H81.0264V85.8086H82.3936V86.9775H81.0264V90.9424C81.0264 91.2523 81.097 91.4801 81.2383 91.626C81.3796 91.7718 81.6006 91.8447 81.9014 91.8447C82.1201 91.8447 82.2819 91.8333 82.3867 91.8105V92.9795C82.2044 93.0251 81.931 93.0479 81.5664 93.0479C80.8418 93.0479 80.3223 92.8997 80.0078 92.6035C79.6979 92.3027 79.543 91.8037 79.543 91.1064V86.9775H78.4971V85.8086H79.543V84.1064ZM83.665 93V83.1357H85.1279V87.0117H85.1621C85.3626 86.5879 85.6566 86.262 86.0439 86.0342C86.4313 85.8018 86.8962 85.6855 87.4385 85.6855C88.2223 85.6855 88.8376 85.9271 89.2842 86.4102C89.7354 86.8932 89.9609 87.5449 89.9609 88.3652V93H88.4775V88.6523C88.4775 88.1146 88.3431 87.6976 88.0742 87.4014C87.8099 87.1051 87.4202 86.957 86.9053 86.957C86.363 86.957 85.9323 87.1302 85.6133 87.4766C85.2988 87.8184 85.1416 88.2741 85.1416 88.8438V93H83.665ZM91.4375 93V85.8086H92.9141V93H91.4375ZM92.7842 84.5098C92.6156 84.6738 92.4128 84.7559 92.1758 84.7559C91.9388 84.7559 91.736 84.6738 91.5674 84.5098C91.4033 84.3457 91.3213 84.1475 91.3213 83.915C91.3213 83.6781 91.4033 83.4775 91.5674 83.3135C91.736 83.1494 91.9388 83.0674 92.1758 83.0674C92.4173 83.0674 92.6201 83.1494 92.7842 83.3135C92.9528 83.4775 93.0371 83.6781 93.0371 83.915C93.0371 84.1475 92.9528 84.3457 92.7842 84.5098ZM94.2949 87.8457C94.2949 87.2031 94.5547 86.6813 95.0742 86.2803C95.5938 85.8792 96.2728 85.6787 97.1113 85.6787C97.9089 85.6787 98.5628 85.8815 99.0732 86.2871C99.5882 86.6882 99.8571 87.21 99.8799 87.8525H98.4922C98.4557 87.5244 98.3122 87.2669 98.0615 87.0801C97.8109 86.8932 97.4805 86.7998 97.0703 86.7998C96.6693 86.7998 96.3457 86.8887 96.0996 87.0664C95.8581 87.2441 95.7373 87.4743 95.7373 87.7568C95.7373 88.1943 96.1042 88.5042 96.8379 88.6865L98.0479 88.9668C98.7725 89.14 99.2852 89.377 99.5859 89.6777C99.8913 89.974 100.044 90.3887 100.044 90.9219C100.044 91.5781 99.766 92.1113 99.21 92.5215C98.6585 92.9316 97.9408 93.1367 97.0566 93.1367C96.2135 93.1367 95.5254 92.9362 94.9922 92.5352C94.4635 92.1341 94.1696 91.6009 94.1104 90.9355H95.5732C95.6325 91.2819 95.7943 91.5485 96.0586 91.7354C96.3229 91.9176 96.6784 92.0088 97.125 92.0088C97.5671 92.0088 97.9157 91.9245 98.1709 91.7559C98.4307 91.5827 98.5605 91.3503 98.5605 91.0586C98.5605 90.8262 98.4831 90.6416 98.3281 90.5049C98.1732 90.3682 97.9089 90.252 97.5352 90.1562L96.25 89.8418C94.9466 89.5273 94.2949 88.862 94.2949 87.8457ZM107.782 85.6924C108.698 85.6924 109.432 86.0273 109.983 86.6973C110.535 87.3672 110.811 88.2695 110.811 89.4043C110.811 90.5391 110.537 91.4437 109.99 92.1182C109.443 92.7881 108.716 93.123 107.81 93.123C107.299 93.123 106.846 93.0068 106.449 92.7744C106.057 92.542 105.757 92.223 105.547 91.8174H105.513V95.3789H104.036V85.8086H105.465V87.0459H105.492C105.706 86.6266 106.014 86.2962 106.415 86.0547C106.816 85.8132 107.272 85.6924 107.782 85.6924ZM107.393 91.8721C107.976 91.8721 108.438 91.651 108.78 91.209C109.122 90.7624 109.293 90.1608 109.293 89.4043C109.293 88.6523 109.122 88.0531 108.78 87.6064C108.438 87.1598 107.976 86.9365 107.393 86.9365C106.827 86.9365 106.372 87.1621 106.025 87.6133C105.679 88.0645 105.506 88.6615 105.506 89.4043C105.506 90.1517 105.677 90.751 106.019 91.2021C106.365 91.6488 106.823 91.8721 107.393 91.8721ZM114.468 91.9541C114.987 91.9541 115.423 91.7969 115.773 91.4824C116.129 91.1634 116.307 90.7715 116.307 90.3066V89.7393L114.536 89.8486C114.094 89.8805 113.752 89.9899 113.511 90.1768C113.274 90.359 113.155 90.6051 113.155 90.915C113.155 91.2295 113.274 91.4824 113.511 91.6738C113.752 91.8607 114.071 91.9541 114.468 91.9541ZM114.058 93.123C113.351 93.123 112.775 92.9225 112.328 92.5215C111.886 92.1204 111.665 91.5986 111.665 90.9561C111.665 90.3271 111.897 89.8281 112.362 89.459C112.827 89.0853 113.486 88.8757 114.338 88.8301L116.307 88.7139V88.1602C116.307 87.7591 116.179 87.4469 115.924 87.2236C115.669 86.9958 115.315 86.8818 114.864 86.8818C114.445 86.8818 114.103 86.9753 113.839 87.1621C113.579 87.349 113.415 87.6064 113.347 87.9346H111.952C111.993 87.2692 112.28 86.7269 112.813 86.3076C113.347 85.8883 114.049 85.6787 114.919 85.6787C115.789 85.6787 116.482 85.8929 116.997 86.3213C117.517 86.7497 117.776 87.3239 117.776 88.0439V93H116.361V91.8174H116.327C116.122 92.2139 115.81 92.5306 115.391 92.7676C114.976 93.0046 114.532 93.123 114.058 93.123ZM119.923 95.6797C119.645 95.6797 119.444 95.6683 119.321 95.6455V94.4492C119.394 94.4674 119.554 94.4766 119.8 94.4766C120.146 94.4766 120.417 94.3968 120.613 94.2373C120.809 94.0824 120.964 93.8203 121.078 93.4512C121.078 93.4466 121.101 93.3714 121.146 93.2256L121.208 93.0068L118.61 85.8086H120.21L122.035 91.6602H122.056L123.881 85.8086H125.439L122.739 93.376C122.434 94.2464 122.076 94.848 121.666 95.1807C121.256 95.5133 120.675 95.6797 119.923 95.6797ZM126.308 93V85.8086H127.716V87.0186H127.75C127.914 86.613 128.176 86.2894 128.536 86.0479C128.896 85.8063 129.315 85.6855 129.794 85.6855C130.291 85.6855 130.712 85.8086 131.059 86.0547C131.41 86.3008 131.658 86.6471 131.804 87.0938H131.838C132.025 86.6562 132.316 86.3122 132.713 86.0615C133.114 85.8109 133.57 85.6855 134.08 85.6855C134.791 85.6855 135.361 85.902 135.789 86.335C136.217 86.7679 136.432 87.3421 136.432 88.0576V93H134.948V88.4131C134.948 87.9482 134.827 87.5882 134.586 87.333C134.349 87.0778 134.012 86.9502 133.574 86.9502C133.137 86.9502 132.779 87.096 132.501 87.3877C132.228 87.6794 132.091 88.0531 132.091 88.5088V93H130.642V88.3037C130.642 87.889 130.519 87.5609 130.272 87.3193C130.026 87.0732 129.696 86.9502 129.281 86.9502C128.844 86.9502 128.484 87.1029 128.201 87.4082C127.923 87.709 127.784 88.0918 127.784 88.5566V93H126.308ZM142.119 87.3877C141.796 87.0413 141.379 86.8682 140.868 86.8682C140.358 86.8682 139.934 87.0436 139.597 87.3945C139.259 87.7409 139.073 88.1898 139.036 88.7412H142.632C142.614 88.1852 142.443 87.734 142.119 87.3877ZM142.625 90.8877H144.026C143.922 91.5485 143.584 92.0885 143.015 92.5078C142.445 92.9271 141.75 93.1367 140.93 93.1367C139.877 93.1367 139.048 92.8063 138.441 92.1455C137.84 91.4801 137.539 90.5778 137.539 89.4385C137.539 88.3083 137.84 87.3991 138.441 86.7109C139.048 86.0228 139.856 85.6787 140.868 85.6787C141.862 85.6787 142.65 86.0046 143.233 86.6562C143.817 87.3034 144.108 88.1738 144.108 89.2676V89.7734H139.029V89.8623C139.029 90.4912 139.205 90.9948 139.556 91.373C139.907 91.7513 140.376 91.9404 140.964 91.9404C141.379 91.9404 141.734 91.8447 142.03 91.6533C142.326 91.4619 142.525 91.2067 142.625 90.8877ZM145.257 93V85.8086H146.665V87.0117H146.699C146.9 86.5924 147.191 86.2666 147.574 86.0342C147.957 85.8018 148.42 85.6855 148.962 85.6855C149.75 85.6855 150.363 85.9225 150.801 86.3965C151.238 86.8659 151.457 87.5153 151.457 88.3447V93H149.974V88.6318C149.974 88.085 149.844 87.6702 149.584 87.3877C149.329 87.1006 148.948 86.957 148.442 86.957C147.923 86.957 147.508 87.1257 147.198 87.4629C146.888 87.8001 146.733 88.249 146.733 88.8096V93H145.257ZM153.316 84.1064H154.8V85.8086H156.167V86.9775H154.8V90.9424C154.8 91.2523 154.87 91.4801 155.012 91.626C155.153 91.7718 155.374 91.8447 155.675 91.8447C155.894 91.8447 156.055 91.8333 156.16 91.8105V92.9795C155.978 93.0251 155.704 93.0479 155.34 93.0479C154.615 93.0479 154.096 92.8997 153.781 92.6035C153.471 92.3027 153.316 91.8037 153.316 91.1064V86.9775H152.271V85.8086H153.316V84.1064Z" fill="#094172"/>
              <path d="M88.6785 46.9363C88.8935 47.1514 89.1744 47.2565 89.4548 47.2565C89.7357 47.2565 90.0165 47.1492 90.2312 46.9363C90.6591 46.5084 90.6591 45.8133 90.2312 45.3854L78.7795 33.9358C78.778 33.9344 78.7765 33.9329 78.7751 33.9314L78.7115 33.8678C78.319 33.4754 77.6827 33.4754 77.2903 33.8678L77.2289 33.9292C77.2274 33.9307 77.2259 33.9321 77.2245 33.9336L65.7701 45.3857C65.3422 45.8136 65.3422 46.5088 65.7701 46.9367C66.198 47.3646 66.8932 47.3646 67.3211 46.9367L76.9043 37.3557V56.6758C76.9043 57.2812 77.3958 57.7723 78.0009 57.7723C78.6063 57.7723 79.0974 57.2808 79.0974 56.6758V37.3553L88.6785 46.9363Z" fill="#094172"/>
              <path d="M99.53 26.8769C96.8299 19.281 89.7012 14.2227 81.5829 14.2227C73.9322 14.2227 67.0509 18.8244 64.0744 25.7998C62.6727 25.1506 61.1482 24.8127 59.5999 24.8127C53.6994 24.8127 48.8958 29.6078 48.8848 35.5058C45.8164 37.853 44 41.4985 44 45.3768C44 52.2118 49.5759 57.7722 56.6127 57.7744C56.6917 57.7744 56.7707 57.7766 56.841 57.7766C56.9156 57.7766 56.9814 57.7766 57.034 57.7722H68.5934C69.1989 57.7722 69.69 57.2807 69.69 56.6756C69.69 56.0706 69.1985 55.5791 68.5934 55.5791H56.9766C56.8693 55.5857 56.7571 55.5813 56.6498 55.5791L56.4259 55.5769C50.7842 55.5769 46.1935 51.0012 46.1935 45.375C46.1935 42.0124 47.8518 38.8602 50.6287 36.9475L51.1331 36.4454L51.0783 35.5286C51.0783 30.8301 54.9015 27.007 59.5999 27.007C61.1747 27.007 62.7212 27.45 64.0722 28.2859L65.2324 29.0053L65.6842 27.7154C68.0486 20.9573 74.4362 16.4191 81.5847 16.4191C88.9638 16.4191 95.4212 21.1418 97.6518 28.1738L97.8559 28.8164L98.5227 28.9237C105.059 29.981 109.806 35.5525 109.806 42.1724C109.806 49.5665 103.776 55.5809 96.3667 55.5809H87.4062C86.8008 55.5809 86.3096 56.0724 86.3096 56.6775C86.3096 57.2826 86.8011 57.7741 87.4062 57.7741H96.3667C104.987 57.7741 112 50.7748 112 42.172C111.998 34.6922 106.793 28.3642 99.53 26.8769Z" fill="#094172"/>
            </svg>
            <input type="file" multiple v-on:change="handleFilesUpload">
          </div>
          <p class="fz14 text-dark">Drag and drop files in here</p>
          <p class="fz12 text-gray">or</p>
          <button class="fz14 fw500 blue-button h32 buttonW120">
            Browse files
            <input type="file" multiple v-on:change="handleFilesUpload">
          </button>
        </div>
        <payment-detail-atachements-file
            :add-file-permission="getPermissionForAddFile() && !getPermissionEditPaymentInStatusPaid() && !getPermissionBlockChangePaidDateAndBankReceipt()"
            :edit-permission="(getPermissionEditPayment() || getPermissionEditAndRemoveFile()) && !getPermissionEditPaymentInStatusPaid() && !getPermissionBlockChangePaidDateAndBankReceipt()"
            v-if=" $route.path.indexOf('accounting-invoice') === -1"
            ref="fileReceipt"
            :class="{'normal-position' : getPermissionEditPaymentInStatusPaid() || getPermissionBlockChangePaidDateAndBankReceipt()}"
            class="file-attachments-two"
            :class-for-title="'fz13 text-gray mt12'"
            :file-props="getInfoDetailPayment.receipt_files"
            :await-delete-file="true"
            @emitBeforeDeleteFileFillFile="openModalDeleteFile1"
            @fileDeleted="renderNew"
            @addFile="addFilesToC"
            @changeParentId="setParentsIDForFileReport"
            :deleteFilePermission="getPermissionDeleteFile() && (!getPermissionEditPaymentInStatusPaid() || getPermissionEditPayment()) && !getPermissionBlockChangePaidDateAndBankReceipt()"
            :disabled-add-new-folder="loadAddFolder"
        >
        </payment-detail-atachements-file>
        <payment-chat :id="getInfoDetailPayment.id" :edit-permission="(getPermissionEditPayment() || getPermissionForAddFile()) && !getPermissionEditPaymentInStatusPaid()" class="chat" v-if=" $route.path.indexOf('accounting-invoice') === -1 && getInfoDetailPayment" @addFile="chatAddFile"></payment-chat>
      </div>
      <div v-else class="block-reports hide-block-reports">
        <div>
          <svg width="124" height="92" viewBox="0 0 124 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_2697_7024" fill="white">
              <path d="M29 87V10.9577C29 7.66734 31.6886 5 35.0052 5H78.2911L95 21.5766V87L84.0478 83.0282L73.0383 87L61.7785 83.0282L51.0191 87L40.51 83.0282L29 87Z"/>
            </mask>
            <path d="M79.2911 5C79.2911 4.44772 78.8434 4 78.2911 4C77.7389 4 77.2911 4.44772 77.2911 5H79.2911ZM95 22.5766C95.5523 22.5766 96 22.1289 96 21.5766C96 21.0243 95.5523 20.5766 95 20.5766V22.5766ZM67.033 26.8166C67.5853 26.8166 68.033 26.3689 68.033 25.8166C68.033 25.2643 67.5853 24.8166 67.033 24.8166V26.8166ZM45.0139 24.8166C44.4616 24.8166 44.0139 25.2643 44.0139 25.8166C44.0139 26.3689 44.4616 26.8166 45.0139 26.8166V24.8166ZM79.0435 38.7319C79.5958 38.7319 80.0435 38.2842 80.0435 37.7319C80.0435 37.1796 79.5958 36.7319 79.0435 36.7319V38.7319ZM45.0139 36.7319C44.4616 36.7319 44.0139 37.1796 44.0139 37.7319C44.0139 38.2842 44.4616 38.7319 45.0139 38.7319V36.7319ZM79.0435 51.6402C79.5958 51.6402 80.0435 51.1925 80.0435 50.6402C80.0435 50.0879 79.5958 49.6402 79.0435 49.6402V51.6402ZM45.0139 49.6402C44.4616 49.6402 44.0139 50.0879 44.0139 50.6402C44.0139 51.1925 44.4616 51.6402 45.0139 51.6402V49.6402ZM79.0435 63.5556C79.5958 63.5556 80.0435 63.1079 80.0435 62.5556C80.0435 62.0033 79.5958 61.5556 79.0435 61.5556V63.5556ZM45.0139 61.5556C44.4616 61.5556 44.0139 62.0033 44.0139 62.5556C44.0139 63.1079 44.4616 63.5556 45.0139 63.5556V61.5556ZM77.2911 5V16.6118H79.2911V5H77.2911ZM83.2955 22.5766H95V20.5766H83.2955V22.5766ZM77.2911 16.6118C77.2911 19.9135 79.9869 22.5766 83.2955 22.5766V20.5766C81.0764 20.5766 79.2911 18.794 79.2911 16.6118H77.2911ZM67.033 24.8166H45.0139V26.8166H67.033V24.8166ZM79.0435 36.7319H45.0139V38.7319H79.0435V36.7319ZM79.0435 49.6402H45.0139V51.6402H79.0435V49.6402ZM79.0435 61.5556H62.0287V63.5556H79.0435V61.5556ZM62.0287 61.5556H45.0139V63.5556H62.0287V61.5556ZM29 87H27C27 87.6466 27.3126 88.2533 27.8391 88.6286C28.3657 89.0039 29.0412 89.1015 29.6524 88.8906L29 87ZM78.2911 5L79.6997 3.58018C79.3251 3.20854 78.8188 3 78.2911 3V5ZM95 21.5766H97C97 21.0434 96.7871 20.5323 96.4086 20.1568L95 21.5766ZM95 87L94.3182 88.8802C94.9312 89.1025 95.6141 89.012 96.1481 88.6376C96.6821 88.2633 97 87.6521 97 87H95ZM40.51 83.0282L41.2171 81.1574C40.7801 80.9922 40.2992 80.9852 39.8576 81.1376L40.51 83.0282ZM51.0191 87L50.3121 88.8708C50.7627 89.0412 51.2598 89.0431 51.7117 88.8762L51.0191 87ZM84.0478 83.0282L84.7297 81.148C84.2902 80.9887 83.8088 80.9883 83.3691 81.1469L84.0478 83.0282ZM73.0383 87L72.373 88.8861C72.8081 89.0396 73.2829 89.0379 73.717 88.8813L73.0383 87ZM61.7785 83.0282L62.4438 81.1421C62.0038 80.9869 61.5235 80.9904 61.0859 81.152L61.7785 83.0282ZM31 87V10.9577H27V87H31ZM35.0052 7H78.2911V3H35.0052V7ZM93 21.5766V87H97V21.5766H93ZM76.8826 6.41982L93.5914 22.9964L96.4086 20.1568L79.6997 3.58018L76.8826 6.41982ZM39.8576 81.1376L28.3476 85.1094L29.6524 88.8906L41.1624 84.9188L39.8576 81.1376ZM51.7262 85.1292L41.2171 81.1574L39.8029 84.8991L50.3121 88.8708L51.7262 85.1292ZM95.6818 85.1198L84.7297 81.148L83.366 84.9084L94.3182 88.8802L95.6818 85.1198ZM83.3691 81.1469L72.3596 85.1187L73.717 88.8813L84.7265 84.9095L83.3691 81.1469ZM73.7036 85.1139L62.4438 81.1421L61.1132 84.9143L72.373 88.8861L73.7036 85.1139ZM61.0859 81.152L50.3265 85.1238L51.7117 88.8762L62.4711 84.9045L61.0859 81.152ZM31 10.9577C31 8.78687 32.7782 7 35.0052 7V3C30.5991 3 27 6.54782 27 10.9577H31Z" fill="#DEE3EA" mask="url(#path-1-inside-1_2697_7024)"/>
          </svg>
          <p class="fz16 fw500 text-dark mt16">Report information is not available</p>
        </div>
      </div>
      <div>
        <payment-detail-activity v-if="!idPayment" ref="activity"></payment-detail-activity>
<!--        <pre>{{getInfoDetailPayment}}</pre>-->
      </div>
    </div>
    <transition name="fade">
      <div class="modal-delete-file" v-if="modalDeleteShow">
        <div class="filter" v-on:click="closeModalDeleteFile"></div>
        <div class="content-modal">
          <div class="modal-top-panel">
            <p class="fz16 fw500">Delete file</p>
            <button class="close-modal" v-on:click="closeModalDeleteFile">
              <svg class="svg-dart" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.51375 7.57923C6.21612 7.28453 6.21612 6.80673 6.51375 6.51204C6.81138 6.21734 7.29392 6.21734 7.59155 6.51204L17.4863 16.298C17.784 16.5927 17.784 17.0705 17.4863 17.3652C17.1887 17.6599 16.7062 17.6599 16.4085 17.3652L6.51375 7.57923Z" fill="#222222"/>
                <path d="M16.4086 6.63595C16.7063 6.34126 17.1888 6.34126 17.4864 6.63596C17.7841 6.93065 17.7841 7.40845 17.4864 7.70314L7.59165 17.4891C7.29402 17.7838 6.81148 17.7838 6.51385 17.4891C6.21622 17.1944 6.21622 16.7166 6.51385 16.4219L16.4086 6.63595Z" fill="#222222"/>
              </svg>
            </button>
          </div>
          <p class="text-modal">Are you sure you want to delete the file {{nameFileForDelete}}?</p>
          <div class="modal-bottom-panel">
            <button class="blue-button-text fz14" v-on:click="closeModalDeleteFile">Cancel</button>
            <button class="blue-button fz14 fw500 buttonW100 h32" v-on:click="deleteFileInPayment(idFileForDelete)">Delete</button>
          </div>
        </div>
      </div>
    </transition>
<!--    <pre>-->
<!--      {{getInfoDetailPayment}}-->
<!--      </pre>-->
    <transition name="fade">
      <div class="modal-delete-file" v-if="modalDeleteShow1">
        <div class="filter"></div>
        <div class="content-modal">
          <div class="modal-top-panel">
            <p class="fz16 fw500">Delete file</p>
            <button class="close-modal">
              <svg class="svg-dart" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.51375 7.57923C6.21612 7.28453 6.21612 6.80673 6.51375 6.51204C6.81138 6.21734 7.29392 6.21734 7.59155 6.51204L17.4863 16.298C17.784 16.5927 17.784 17.0705 17.4863 17.3652C17.1887 17.6599 16.7062 17.6599 16.4085 17.3652L6.51375 7.57923Z" fill="#222222"/>
                <path d="M16.4086 6.63595C16.7063 6.34126 17.1888 6.34126 17.4864 6.63596C17.7841 6.93065 17.7841 7.40845 17.4864 7.70314L7.59165 17.4891C7.29402 17.7838 6.81148 17.7838 6.51385 17.4891C6.21622 17.1944 6.21622 16.7166 6.51385 16.4219L16.4086 6.63595Z" fill="#222222"/>
              </svg>
            </button>
          </div>
          <p class="text-modal">Are you sure you want to delete the file {{nameFileForDelete1}}?</p>
          <div class="modal-bottom-panel">
            <button class="blue-button-text fz14" v-on:click="closeModalDeleteFile1">Cancel</button>
            <button class="blue-button fz14 fw500 buttonW100 h32" v-on:click="deleteFileReceiptInPayment(idFileForDelete1)">Delete</button>
          </div>
        </div>
      </div>
    </transition>

    <div id="plot"></div>
    <counterparties-add class="add-client-modal" @close="showAddClient = false" :inside-block-type-modal="true" :key="showAddClient" v-if="showAddClient"></counterparties-add>
    <app-loader :is-local="true" v-if="showLoader"></app-loader>
  </div>

</template>

<script>
import linkedWrap from '@/components/entries/linked/linkedWrap'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PaymentDetailOptionButton from "@/components/paymentDetail/payment-detail-option-button";
import {mapActions, mapGetters, mapMutations} from "vuex";
import Vue from 'vue';
import moment from 'moment';
import PaymentDetailAtachementsFile from "@/components/paymentDetail/paymentDetailAtachementsFile";
import VueClipboard from "vue-clipboard2";
import PaymentChat from "@/components/payment/payment-chat/payment-chat";
import PaymentDetailActivity from "@/components/paymentDetail/payment-detail-activity/payment-detail-activity";
import AsyncSelect from "@/components/reuse/asyncSelect";
import CounterpartiesDrop from "@/components/counterparties/counterpartiesAdd/counterpartiesDrop";
import InputFormatNumber from "@/components/reuse/inputFormatNumber";
import BankAndCashSelect from "@/components/reuse/bankAndCashSelect";
import CounterpartiesAdd from "@/views/counterparties/counterpartiesAdd";
import AppLoader from "@/components/loader";
Vue.prototype.$moment = moment;
Vue.use(VueClipboard)
export default {
  name: "paymentDetail",
  components: {
    AppLoader,
    CounterpartiesAdd,
    BankAndCashSelect,
    InputFormatNumber,
    CounterpartiesDrop,
    AsyncSelect,
    linkedWrap,
    PaymentDetailActivity,
    PaymentChat, DatePicker, PaymentDetailAtachementsFile, PaymentDetailOptionButton},
  computed: {
    ...mapGetters(["getPermissionsFullByType", "getPermissionsByType", "getInfoDetailPayment", "getPaymentsCash", "getDataContractV", "getValutaList"]),
    getCPDateListStatement() {
      if(this.getInfoDetailPayment && this.getInfoDetailPayment.ship) {
        let vessel = JSON.parse(JSON.stringify(this.getInfoDetailPayment.ship));
        if(vessel !== null) {
          let cp_dates = [];
          // if(vessel.cp_date?.length) {
          //   cp_dates.push(vessel.cp_date)
          // }

          if(vessel.cargo_contracts?.length) {
            if(this.getInfoDetailPayment.client && !this.getInfoDetailPayment.real_account) {
              vessel.cargo_contracts =  vessel.cargo_contracts.filter(a=> a.owner === this.getInfoDetailPayment.client.id)
            }
            if(this.getInfoDetailPayment.real_account) {
              vessel.cargo_contracts =  vessel.cargo_contracts.filter(a=> a.owner === this.getInfoDetailPayment.real_account.id)
            }
            vessel.cargo_contracts.map(a=> {
              if(a.cp_date?.length) {
                cp_dates.push(a.cp_date)
              }
            })
          }
          cp_dates = Array.from(new Set(cp_dates));
          cp_dates = cp_dates.map(a=> {
            return {name: a, id: a}
          })
          cp_dates = cp_dates.sort((a, b) => new Date(a.name) - new Date(b.name));
          // cp_dates.push({name: "Unselected", id: -1})
          return cp_dates;
        }
        let cp_dates = [];

        // cp_dates.push({name: "Unselected", id: -1})
        return cp_dates;
      }

      return  []

    },

  },
  props: {
    idPayment: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      showAddClient: false,
      keyRender: -9999,
      cashDefaultActive: {},
      activeBankAccount: [],
      offsetX: 0,
      offsetY: 0,
      date: "",
      dragMode: false,
      files: [],
      errorDate: false,
      errorFiles: false,
      modalDeleteShow: false,
      nameFileForDelete: "",
      idFileForDelete: null,
      modalDeleteShow1: false,
      nameFileForDelete1: "",
      idFileForDelete1: null,
      countRequests: 0,
      keyRenderClient: -34234,
      parent_idReport: null,
      parent_id: null,
      loadAddFolder: false,
      loadAddFolder1: false,
      showTimePanel: false,
      showLoader: false,
    }
  },
  watch: {
    showAddClient: function () {
      this.$emit('statusShowAddCounterparties', this.showAddClient)
    },
    idPayment: function() {
      if(this.idPayment) {
        setTimeout(()=> {
          this.renderNew()
        }, 50)
      }
    },
    $route() {
      this.$forceUpdate();
      // if(!this.getPaymentsCash.length) {
      //   this.axiosGetPaymentCash().then(()=> {
      //     // console.log(100)
      //     // console.log(this.getPaymentsCash)
      //     if(this.getInfoDetailPayment !== {}) {
      //       // console.log(200)
      //
      //       if(this.getInfoDetailPayment.cash !== null) {
      //         this.cashDefaultActive = {id: this.getInfoDetailPayment.cash.id, name: this.getInfoDetailPayment.cash.name, disabled: false, type: 'cash'}
      //       }
      //       if(this.getInfoDetailPayment.bank !== null) {
      //         this.cashDefaultActive = {id: this.getInfoDetailPayment.bank.id, name: this.getInfoDetailPayment.bank.holder, type: this.getInfoDetailPayment.bank.cash.type, currency: this.getInfoDetailPayment.bank.currency, disabled: false}
      //       }
      //       // console.log(300)
      //       // console.log(this.cashDefaultActive)
      //     }
      //   });
      // }
      this.renderNew();
    },
    countRequests: function () {
      if(this.countRequests === 0) {
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
      } else {
        if(!this.idPayment) {
          this.showLoad()
        } else {
          this.showLoader = true;
        }
      }
    }
  },
  methods: {
    ...mapActions(["axiosAddFilesToObject", "axiosChangeNote", "axiosGetCurrency", "axiosArchivePayment", "axiosPaymentRemoveFileReceipt", "axiosFileDelete", "axiosPaymentRemoveFile", "axiosChangeBankAndCashAccountForPayment", "axiosSetDatePaid", "axiosPaymentAddFilesReceipt", "axiosGetFullInfoForDetailPayment", "axiosChangeStatusPayment", "axiosPaymentAddFiles", "axiosGetPaymentCash", 'axiosChangePaymentLinked']),
    ...mapMutations(["addTip", "hideLoad", "showLoad"]),
    testCpDatesListAfterDelete() {
      console.log('testCpDatesListAfterDelete', 'this.getInfoDetailPayment:', this.getInfoDetailPayment, 'this.getInfoDetailPayment.ship:', this.getInfoDetailPayment.ship)
      if(this.getInfoDetailPayment && this.getInfoDetailPayment.ship) {
        console.log(1)
        let vessel = JSON.parse(JSON.stringify(this.getInfoDetailPayment.ship));
        console.log('vessel: ', vessel)
        if(vessel !== null) {
          console.log(2)
          let cp_dates = [];
          // if(vessel.cp_date?.length) {
          //   cp_dates.push(vessel.cp_date)
          // }
          console.log('vessel-befo: ', vessel.cargo_contracts)

          if(vessel.cargo_contracts?.length) {
            console.log(3)
            if(this.getInfoDetailPayment.client && !this.getInfoDetailPayment.real_account) {
              console.log('3-1')
              vessel.cargo_contracts =  vessel.cargo_contracts.filter(a=> a.owner === this.getInfoDetailPayment.client.id)
            }
            if(this.getInfoDetailPayment.real_account) {
              console.log('3-2')
              vessel.cargo_contracts =  vessel.cargo_contracts.filter(a=> a.owner === this.getInfoDetailPayment.real_account.id)
            }
            console.log('vessel-afte: ', vessel.cargo_contracts)

            vessel.cargo_contracts.map(a=> {
              if(a.cp_date?.length) {
                cp_dates.push(a.cp_date)
              }
            })
            console.log(4)
            console.log('cp_dates: ', cp_dates)

          }
          cp_dates = Array.from(new Set(cp_dates));
          console.log(5)
          console.log('cp_dates: ', cp_dates)

          cp_dates = cp_dates.map(a=> {
            return {name: a, id: a}
          })
          console.log(6)
          console.log('cp_dates: ', cp_dates)
          // cp_dates.push({name: "Unselected", id: -1})
          return cp_dates;
        }
        let cp_dates = [];

        // cp_dates.push({name: "Unselected", id: -1})
        return cp_dates;
      }

      return  []
    },
    disabledRange(date) {
      return date > new Date()
    },
    getPermissionChangePaidDate() {
      if(this.getPermissionEditPayment() && !this.getPermissionEditPaymentInStatusPaid() && !this.getPermissionBlockChangePaidDateAndBankReceipt() && this.getPermissionEditPaidDate()) {
        return true;
      }
      return false
    },
    getPermissionsHideTheBlockBankAndCashAccountsInTheStatusNotPaid() {
      return (this.getPermissionsByType('hide_the_block_bank_and_cash_accounts_in_the_status_not_paid') && this.getInfoDetailPayment.status === 'not_paid')
    },
    getPermissionHideReportInStatusNotPaid() {
      return (this.getPermissionsByType('hide_the_block_report_information_in_payment_income_in_the_status_not_paid') && this.getInfoDetailPayment.status === 'not_paid')
    },
    getPermissionShowDopColumnsFull() {
      return this.getPermissionsFullByType('show_dop_menu_choosed_columns_in_payment_list')
    },
    changeCurrency(data) {
      this.getInfoDetailPayment.currency = data.id;
      // s
      // this.changePaymentData(this.getPaymentListOriginal[this.indexBeforeChangeCurrency].id, 'currency', 'object', data, 'Currency')
    },
    getBoolDontSelect(data) {
      if(data.bank) {
        if(data.bank.currency !== null && (''+data.bank.currency).length !== 0) {
          return true
        }
      }
      if(data.cash) {
        if(data.cash.currency !== null && (''+data.cash.currency).length !== 0) {
          return true
        }
      }
      return false
    },
    selectCPDateStatement(data) {
      console.log(data);
      this.getInfoDetailPayment.statement_member = data ? data.name : null;
    },
    getTextAccountTitle(account) {
      return account? this.getPermissionShowDopInfoAcc() ? account.account_id + ": " + account.name :  account.name : ''
    },
    getFormatDate(date) {
      if(date !==null && (""+date).length !==0) {
        return "" + moment(date).format('DD.MM.YYYY')
      } else {
        return ""
      }
    },
    async changeCurrencyAmount(currency) {
      if(currency !== 'USD') {
        let paid_date = this.getInfoDetailPayment.paid_date
        let currences = []
        if(paid_date !== null) {
          currences = await this.axiosGetCurrency({currency: currency, created_at: moment(paid_date).format('YYYY-MM-DD')});
        }
        let rate = 0;
        if(paid_date !== null && currences?.data?.results?.length !== 0) {
          rate = Math.round(currences.data.results[0].rate*10000)/10000
        } else {
          currences = await this.axiosGetCurrency({currency: currency});
          rate = Math.round(currences.data.results[0].rate*10000)/10000
        }
        // this.axiosGetCurrency({currency: currency, created_at: moment().add(-1, 'day').format('YYYY-MM-DD')}).then(response=> {
        //   let rate = response.data.results[0].rate;
        this.getInfoDetailPayment.currency_amount = this.numberFloatCheck(this.checkNum(((Math.round(((this.getInfoDetailPayment.payment_amount / rate))*100)))/100));
          this.changePaymentData(this.getInfoDetailPayment.id, 'currency_amount', 'number', this.getInfoDetailPayment.currency_amount, 'USD amount')
        // })
      } else {
        let rate = 1;
        this.getInfoDetailPayment.currency_amount = this.numberFloatCheck(this.checkNum(((Math.round(((this.getInfoDetailPayment.payment_amount / rate))*100)))/100));
        setTimeout(()=> {
          this.changePaymentData(this.getInfoDetailPayment.id, 'currency_amount', 'number', this.getInfoDetailPayment.currency_amount, 'USD amount')
        }, 100)
      }
    },
    changePaymentData(id, nameValue, typeData, data, nameColumn) {
      if(!this.getPermissionEditPaymentInStatusPaid() && this.getPermissionEditPayment()) {
        let bool = true;
        let form = {}
        if(typeData === 'date') {
          form[nameValue] = (data !== null && (''+data).length !== 0) ? moment(data).format('YYYY-MM-DD HH:mm') : null
        }
        if(typeData === 'text') {
          form[nameValue] = (data !== null && (''+data).length !== 0) ? data : null
          if(nameValue === 'currency') {
            this.changeCurrencyAmount(this.getInfoDetailPayment.currency)
          }
          if(nameValue === 'payment_type') {
            this.getInfoDetailPayment.payment_type = data
          }
          if(nameValue === 'client_name') {
            // console.log(data)
            // console.log(this.getPaymentListOriginal[index].client_name)
            if(data === this.getInfoDetailPayment.client_name || ((data === '' && this.getInfoDetailPayment.client_name === null) || (data === null && this.getInfoDetailPayment.client_name === ''))) {
              bool = false;
            } else if(this.getInfoDetailPayment.client !== null) {
              if(data !== this.getInfoDetailPayment.client?.company_name) {
                form['client'] = null;
                this.getInfoDetailPayment.client = null;
                this.addTip('Counterparty removed')
                form['statement_member'] = ''
                this.getInfoDetailPayment['statement_member'] = '';
              }
            }
            this.getInfoDetailPayment.client_name = data;
          }
          if(nameValue === 'account_name') {
            if(data === this.getInfoDetailPayment.account_name || ((data === '' && this.getInfoDetailPayment.account_name === null) || (data === null && this.getInfoDetailPayment.account_name === ''))) {
              bool = false;
            } else if(this.getInfoDetailPayment.account !== null) {
              if(data !== this.getTextAccountTitle(this.getInfoDetailPayment.account)) {
                form['account'] = null;
                this.getInfoDetailPayment.account = null;
                this.addTip('Reference removed')
              }
            }
            this.getInfoDetailPayment.account_name = data;
          }
        }
        if(typeData === 'object') {
          if(nameValue === 'bank' || nameValue === 'cash') {
            if(nameValue === 'bank') {
              this.getInfoDetailPayment.bank = data;
              this.getInfoDetailPayment.cash = null;
              form['bank'] = (data !== null && (''+data).length !== 0) ? data.id : null;
              form['cash'] = null
            } else {
              this.getInfoDetailPayment.cash = data;
              this.getInfoDetailPayment.bank = null;
              form['cash'] = (data !== null && (''+data).length !== 0) ? data.id : null;
              form['bank'] = null
            }
            if(data && data?.currency !== null) {
              form['currency'] = data.currency
              this.getInfoDetailPayment['currency'] = data.currency;
              this.changeCurrencyAmount(this.getInfoDetailPayment.currency)
            }
          } else {
            if(nameValue === 'ship') {
              form['statement_member'] = ''
              this.getInfoDetailPayment.statement_member = '';
            }
            if(nameValue === 'client') {
              form['statement_member'] = ''
              this.getInfoDetailPayment['statement_member'] = '';
              form['client_name'] = data ? data.company_name : null;
              this.getInfoDetailPayment.client_name = data ? data.company_name : "";
            }
            if(nameValue === 'account') {
              form['account_name'] = data ? this.getTextAccountTitle(this.getInfoDetailPayment.account) : null;
              this.getInfoDetailPayment.account_name =  data ? this.getTextAccountTitle(this.getInfoDetailPayment.account) : "";
            }
            form[nameValue] = (data !== null && (''+data).length !== 0) ? data.id : null
          }
          if(nameValue === 'real_account') {
            form['statement_member'] = ''
            this.getInfoDetailPayment['statement_member'] = '';
          }
        }
        if(typeData === 'ship') {
          form['statement_member'] = ''
          this.getInfoDetailPayment['statement_member'] = '';
          form['cp_date'] = (data !== null && (''+data).length !== 0) ? data.cp_date : null
          form[nameValue] = (data !== null && (''+data).length !== 0) ? data.id : null
        }
        if(typeData === 'array') {
          form[nameValue] = (Array.isArray(data) === true) ? data.map(a=> {return a.id}) : null
        }
        if(typeData === 'number' && (nameValue === 'payment_amount_expanse' || nameValue === 'payment_amount_income' || nameValue === 'payment_amount')) {
          if(data !== null && data !== this.getInfoDetailPayment.payment_amount) {
            form['payment_type'] = (nameValue === 'payment_amount_expanse') ? 'expense' : 'income';
            form['payment_amount'] = (data !== null && (''+data).length !== 0) ? data : 0
            this.getInfoDetailPayment.payment_type = form.payment_type;
            this.getInfoDetailPayment.payment_amount = (data !== null && (''+data).length !== 0) ? this.numberFloatCheck(data) : 0
            if(this.getInfoDetailPayment.payment_type === 'income') {
              this.getInfoDetailPayment['payment_amount_income'] = this.numberFloatCheck(this.getInfoDetailPayment.payment_amount);
              this.getInfoDetailPayment['payment_amount_expanse'] = '0.00';
            } else {
              this.getInfoDetailPayment['payment_amount_expanse'] = this.numberFloatCheck(this.getInfoDetailPayment.payment_amount);
              this.getInfoDetailPayment['payment_amount_income'] = '0.00';
            }
            this.changeCurrencyAmount(this.getInfoDetailPayment.currency)
          } else {
            if(nameValue === 'payment_amount') {
              form['payment_amount'] = (data !== null && (''+data).length !== 0) ? this.numberFloatCheck(this.checkNum(data)) : 0
              this.getInfoDetailPayment.payment_amount = (data !== null && (''+data).length !== 0) ? this.numberFloatCheck(this.checkNum(data)) : 0
              this.changeCurrencyAmount(this.getInfoDetailPayment.currency)

            } else {
              bool = false
            }
          }
        } else
        if(typeData === 'number') {
          this.getInfoDetailPayment[nameValue] = (data !== null && (''+data).length !== 0) ? this.numberFloatCheck(this.checkNum(data)) : null;

          form[nameValue] = (data !== null && (''+data).length !== 0) ? this.numberFloatCheck(this.checkNum(data)) : null
        }
        if(bool)
          this.axiosChangeNote({id: id, data: form}).then(res=> {
            if(nameColumn) {
              if(res) {
                if(!this.idPayment) {
                  this.$refs.activity.renderActivity();
                }
                this.addTip(nameColumn+ ' changed')
              } else {
                this.addTip(nameColumn+ ' not changed (network error)')
              }
            }
          })
      }
    },

    numberFloatCheck(value) {
      let fixedNumber = value;
      if(!isNaN(value)) {
          fixedNumber = parseFloat(fixedNumber)
          fixedNumber = fixedNumber.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2}).replaceAll(',','')
          if((''+fixedNumber).indexOf('.') === -1) {
            fixedNumber+='.00'
          }
      }
      return fixedNumber
    },
    checkNum(num) {
      if((''+num).indexOf(".")>=0) {
        num = ""+num
        let num1 = num.substring(0, num.indexOf("."));
        let num2 = num.substring(num.indexOf(".") + 1, num.length);
        num1 = num1.replace(/[^0-9]/g, "");
        num2 = num2.replace(/[^0-9]/g, "");
        if(num2.length > 2) {
          num2 = num2.substring(0, 2);
        }
        num = num1 + "." + num2;
      } else {
        num = ""+num
        num = num.replace(/[^0-9]/g, "");
      }
      return num;
    },
    setParentsIDForFile(id) {
      this.parent_id = id;
    },
    setParentsIDForFileReport(id) {
      this.parent_idReport = id;
    },
    getPermissionForAddFile() {
      return this.getPermissionsByType("add_attachments_into_payments_incomes");
    },
    getPermissionEditAndRemoveFile() {
        return this.getPermissionsByType('delete_and_edit_name_of_the_attachments');
    },
    getPermissionEditPaidDate(){
      return this.getPermissionsByType("edit_paid_date");
    },
    getPermissionEditPayment(){
      return this.getPermissionsByType("edit_payments");
    },
    getPermissionDeleteFile(){
      return this.getPermissionsByType("delete_attachments");
    },
    getTextFromPorts(ports) {
      // return (""+ports.map(ac=> {return ac.name + "<br/>"})).replaceAll(",", "");
      if(ports) {
        return ports.name + (ports.country ? '('+ports.country + ')':'')
      }
      return ''
    },
    getFormDateForTime(date) {
      if(date !== null && (""+date).length !== 0) {
        return moment(date).format("DD.MM.YYYY, HH:mm")
      }
      return ""
    },
    closeModalDeleteFile() {
      this.modalDeleteShow = false;
      this.idFileForDelete = null;
      this.nameFileForDelete = "";
    },
    closeModalDeleteFile1() {
      this.modalDeleteShow1 = false;
      this.idFileForDelete1 = null;
      this.nameFileForDelete1 = "";
    },
    handleFilesUpload(e) {
      if(!this.idPayment) {
        this.showLoad();
      } else {
        this.showLoader = true;
      }
      // console.log(e);
      let files = e.target.files;
      if(this.parent_idReport !== null) {
        for(let i=0; i<files.length; i++) {
          files[i]["parent_id"] = this.parent_idReport;
        }
      }
      this.axiosPaymentAddFilesReceipt({id: this.getInfoDetailPayment.id, fileInPayment: this.getInfoDetailPayment.receipt_files, file: files}).then(()=> {
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
        this.renderNew();
        e.target.value = ""
        // this.errorFiles = false;
      }).catch(() => {
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
      });
    },
    addFilesToC(files) {
      if(!this.idPayment) {
        this.showLoad();
      } else {
        this.showLoader = true;
      }
      for(let i=0 ; i<files.length; i++) {
        if(files[i].file_type === 'FOLDER')
          this.loadAddFolder = true
      }
      this.axiosPaymentAddFilesReceipt({id: this.getInfoDetailPayment.id, fileInPayment: this.getInfoDetailPayment.receipt_files, file: files}).then(()=> {
        this.loadAddFolder = false
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
        this.renderNew();
      }).catch(()=> {
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
      });
    },
    setDateReceipt() {
      // console.log(1);
      // console.log(this.date);
      this.countRequests++;
      this.getInfoDetailPayment.paid_date = this.date;
      this.axiosSetDatePaid({id:this.getInfoDetailPayment.id , date: this.date}).then(response=> {
        this.addTip('Paid Date changed')
        this.changeCurrencyAmount(this.getInfoDetailPayment.currency)
        if(response) {
          if(this.date !== null) {
            this.errorDate = false;
          } else {
            this.errorDate = true;
          }
        }
        this.renderNew()
        this.countRequests--;
      });
    },
    dragEnter() {
      this.dragMode = true;
    },
    dragEnd() {
      this.dragMode = false;
    },
    mousePointer(e) {
      // console.log(e);
      this.offsetX = e.pageX;
      this.offsetY = e.pageY;
    },
    openModalDeleteFile(file) {
      this.idFileForDelete = file.id;
      this.nameFileForDelete = file.name;
      this.modalDeleteShow = true;
    },
    openModalDeleteFile1(file) {
      this.idFileForDelete1 = file.id;
      this.nameFileForDelete1 = file.name;
      this.modalDeleteShow1 = true;
    },
    deleteFileInPayment(id) {
      let files = this.getInfoDetailPayment.files.filter(a=> a.id !== id);
      files = files.map(a=> {return a.id})
      // console.log(files)
      if(!this.idPayment) {
        this.showLoad();
      } else {
        this.showLoader = true;
      }
      this.axiosPaymentRemoveFile({id: this.getInfoDetailPayment.id, filesId: files}).then(()=> {
        this.axiosFileDelete(id).then(()=> {
          this.renderNew();
          this.$refs.fileNormal.deleteFileInModalAfterEmit();

        });
      });
      this.closeModalDeleteFile()
    },
    deleteFileReceiptInPayment(id) {
      let files = this.getInfoDetailPayment.receipt_files.filter(a=> a.id !== id);
      files = files.map(a=> {return a.id})
      // console.log(files)
      if(!this.idPayment) {
        this.showLoad();
      } else {
        this.showLoader = true;
      }
      this.axiosPaymentRemoveFileReceipt({id: this.getInfoDetailPayment.id, filesId: files}).then(()=> {
        this.axiosFileDelete(id).then(()=>{
          this.renderNew();
          this.$refs.fileReceipt.deleteFileInModalAfterEmit();

        })
      })
      this.closeModalDeleteFile1()
    },
    createPlot() {
      let newElement = document.createElement("div");
      let plot = document.getElementById('plot');
      newElement.style.left = this.offsetX + "px";
      newElement.style.top = this.offsetY - 55 + "px";
      newElement.className = "beforeCopyLink";
      newElement.innerHTML = "<p class='fz12 text-white'>Copied to clipboard</p>"
      newElement.addEventListener('mouseout', () => {
        // newElement.remove();
        fadeOutEffect();
      })
      function fadeOutEffect() {
        var fadeTarget = newElement;
        var fadeEffect = setInterval(function () {
          if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 1;
          }
          if (fadeTarget.style.opacity > 0) {
            fadeTarget.style.opacity -= 0.1;
          } else {
            clearInterval(fadeEffect);
            newElement.remove();
          }
        }, 50);
      }
      plot.appendChild(newElement)
    },
    copyText(text) {
      this.$copyText(text).then(()=> {
        this.createPlot();
      })
    },
    setActiveBankAccount(data) {
      this.activeBankAccount = data;
      this.cashDefaultActive = data;
      let bank = null;
      let cash = null;
      if(data.type !== undefined && data.type !== null) {
        let currency  = ""
        let oldCurrency = this.getInfoDetailPayment.currency;
        if(this.activeBankAccount.type === 'bank') {
          bank = this.activeBankAccount.id;
          currency = this.activeBankAccount.currency
        } else {
          cash = this.activeBankAccount.id;
          currency = this.activeBankAccount.currency
        }
        if(currency !== oldCurrency) {
          this.changeCurrencyAmount(currency)
        }
        if((bank !== null && cash === null) || (bank === null && cash !== null)) {
          this.countRequests++;
          this.axiosChangeBankAndCashAccountForPayment({id: this.getInfoDetailPayment.id, bank: bank, cash: cash, currency: currency}).then(()=> {
              this.renderNew();
            this.countRequests--;
          });
        }
      }

    },
    // setCash() {
    //   this.axiosChangeBankAndCashAccountForPayment({id: this.getInfoDetailPayment.id, bank: bank, cash: cash, currency: currency}).then(()=> {
    //     this.renderNew();
    //     this.countRequests--;
    //   });
    // },
    // setBank() {
    //   this.axiosChangeBankAndCashAccountForPayment({id: this.getInfoDetailPayment.id, bank: bank, cash: cash, currency: currency}).then(()=> {
    //     this.renderNew();
    //     this.countRequests--;
    //   });
    // },
    setBank(data) {
      if(!data && !this.getInfoDetailPayment.cash) {
        return
      }
      this.changePaymentData(this.getInfoDetailPayment.id, 'bank', 'object', data, 'Bank and Cash Accounts')
    },
    setCash(data) {
      if(!data && !this.getInfoDetailPayment.bank) {
        return
      }
      this.changePaymentData(this.getInfoDetailPayment.id, 'cash', 'object', data, 'Bank and Cash Accounts')
    },
    getNextStatus(status) {
      if(this.getInfoDetailPayment.payment_type === 'expense') {
        if(status === 'not_paid') {
          return 'paid'
        }
        if(status === 'paid') {
          return 'not_paid'
        }
      } else {
        if(status === 'not_paid') {
          return 'paid'
        }
        if(status === 'paid') {
          return 'not_paid'
        }
      }
    },
    getPrevStatus(status) {
      if(this.getInfoDetailPayment.payment_type === 'expense') {
        if(status === 'not_paid') {
          return {name: 'Paid', value: 'paid'}
        }
        if(status === 'paid') {
          return {name: 'Not Paid', value: 'not_paid'}
        }
      } else {
        return {name: 'off', value: ''}
      }
      return {name:"", value: ''}
    },
    getTextForStatus(status) {
      if(status === 'not_paid') {
        return 'Not Paid'
      }
      if(status === 'paid') {
        return 'Paid'
      }
    },
    changeStatus(status) {
      if(!this.getPermissionEditPaymentInStatusPaid()) {
        if(status === 'paid') {
          if(''+this.getInfoDetailPayment.paid_date === 'null') {
            this.errorDate = true;
          } else {
            this.errorDate = false;
          }
          // if(!this.getInfoDetailPayment.receipt_files.length) {
          //   this.errorFiles = true;
          // } else {
          //   this.errorFiles = false;
          // }
        } else {
          // this.errorFiles = false;
          this.errorDate = false;
        }

        if(!this.errorDate) {
          this.countRequests++;
          if(status === 'not_paid') {
            this.changePaymentData(this.getInfoDetailPayment.id, 'statement_member', 'text', '', '')
          }
          this.axiosChangeStatusPayment({id: this.getInfoDetailPayment.id, status: status}).then(()=> {
            this.renderNew();
            this.countRequests--;

          });
        }
      }

    },
    emitChangeStatus(status) {
      if(status.value === 'paid') {
        if(''+this.getInfoDetailPayment.paid_date === 'null') {
          this.errorDate = true;
        } else {
          this.errorDate = false;
        }
        if(!this.getInfoDetailPayment.receipt_files.length) {
          // this.errorFiles = true;
        } else {
          // this.errorFiles = false;
        }
      } else {
        // this.errorFiles = false;
        this.errorDate = false;
      }

      if(!this.errorDate) {
        this.axiosChangeStatusPayment({id: this.getInfoDetailPayment.id, status: status.value}).then(() => {
          this.renderNew();
        });
      }
    },
    getPermissionShowDopInfoAcc() {
      return this.getPermissionsByType('show_dop_info_for_acc_in_payments')
    },
    getPermissionShowVesselAndCpDate() {
      return this.getPermissionsByType('show_vessel_and_cp_date_in_payments')
    },
    getPermissionEditPaymentInStatusPaid() {
      return (!this.getPermissionsByType('can_edit_payment_in_status_paid') && this.getInfoDetailPayment.status === 'paid')
    },
    getPermissionChangeStatus() {
      return this.getPermissionsByType('change_the_status_of_the_payment_income')
    },
    getPermissionHideLinkedOperation() {
      return this.getPermissionsByType('hide_link_operations_in_payments')
    },
    getPermissionBlockChangePaidDateAndBankReceipt() {
      return this.getPermissionsByType('block_paid_date_and_bank_receipt_in_payment_detail')
    },
    changeEmitArchivePayment() {
      let is_archived = this.getInfoDetailPayment.is_archive;
      if(!this.idPayment) {
        this.showLoad();
      } else {
        this.showLoader = true;
      }
      this.axiosArchivePayment({id: this.getInfoDetailPayment.id, is_archived: !is_archived,}).then(()=> {
        // this.renderNew();
        // if(this.$route.path.indexOf('payment/detail') >= 0) {
        //   this.$route.push
        // }
        // console.log(console.log(this.$router.go(-1)))
        if(!is_archived) {
          this.addTip((this.getInfoDetailPayment.client_name ? this.getInfoDetailPayment.client_name : (this.getInfoDetailPayment.payment_type === 'expense' ? 'Payment' : 'Income'))+" is archived")
        } else {
          this.addTip((this.getInfoDetailPayment.client_name ? this.getInfoDetailPayment.client_name : (this.getInfoDetailPayment.payment_type === 'expense' ? 'Payment' : 'Income'))+" is unarchived")
        }
        if(this.$route.path.indexOf('vessels') === -1 && this.$route.path.indexOf('payment/list/detail') >= 0) {
          this.$router.push({name: 'Payment List'})
        } else if(this.$route.path.indexOf('vessels') === -1 && this.$route.path.indexOf('payment/instructions/detail') >= 0) {
          this.$router.push({name: 'Payment Instructions'})
        } else if(this.$route.path.indexOf('vessels') === -1 && this.$route.path.indexOf('payment/calendar/detail') >= 0) {
          this.$router.push({name: 'Payment Calendar'})
        } else if(this.$route.path.indexOf('vessels') === -1 && this.$route.path.indexOf('cashflow/detail') >= 0) {
          this.$router.push({name: 'CashFlow List'})
        } else if(this.$route.path.indexOf('vessels') === -1 && this.$route.path.indexOf('cashflow/diagram/detail') >= 0) {
          this.$router.push({name: 'CashFlow Diagram'})
        } else if(this.$route.path.indexOf('vessels') === -1 && this.$route.name === 'Counterparties Payment Detail') {
          this.$router.push({name: 'Counterparties payments'})
        } else if(this.$route.path.indexOf('vessels') !== -1 && this.getDataContractV !== null) {
          this.$router.push(this.$route.path.indexOf('open/cash-flow') !== -1 ? {name: 'Vessel Cash-Flow'} : '../../')
        } else if(this.$route.path.indexOf('open/accounting-invoice') !== -1) {
          this.$router.push({name: 'Accounting Invoice'})
        } else if(this.$route.path.indexOf('open/cash-flow') !== -1) {
          this.$router.push({name: 'Vessels CashFlow'})
        } else {
          this.$router.go(-1)
        }
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
      })
    },
    renderNew() {
      let textRoute = this.$route.path;
      let idTask = textRoute.replace(/[^0-9]/gim,'');
      if(this.$route.path.indexOf('cash-flow')>=0) {
        idTask = this.$route.params.paymentCashFlowID;
      }
      if(this.$route.path.indexOf('accounting-invoice')>=0) {
        idTask = this.idPayment ? this.idPayment : this.$route.params.paymentAccInvID;
      }
      if(this.$route.path.indexOf('counterparties') >=0) {
        idTask = this.$route.params.idPayment;
      }
      // this.showLoad();
      this.countRequests++;
      this.axiosGetFullInfoForDetailPayment(idTask).then(()=> {
        this.countRequests--;
        this.keyRender++;
        if(this.getInfoDetailPayment.paid_date !== null) {
          this.date = new Date(this.getInfoDetailPayment.paid_date);
        }
        // console.log(1)
        // console.log(this.getPaymentsCash.length);
        this.cashDefaultActive = null;
          if(this.getInfoDetailPayment.cash !== null) {
            this.cashDefaultActive = {id: this.getInfoDetailPayment.cash.id, name: this.getInfoDetailPayment.cash.name, disabled: false, type: 'cash'}
          }
          if(this.getInfoDetailPayment.bank !== null) {
            this.cashDefaultActive = {id: this.getInfoDetailPayment.bank.id, name: this.getInfoDetailPayment.bank.holder, type: this.getInfoDetailPayment.bank.cash.type, currency: this.getInfoDetailPayment.bank.currency, disabled: false}
          }
          // this.keyRenderClient++;
          // console.log("CLIENT")
        // console.log(this.cashDefaultActive)
        // if(!this.getPaymentsCash.length) {
        //   this.axiosGetPaymentCash().then(()=> {
        //     // console.log(100)
        //     // console.log(this.getPaymentsCash)
        //     if(this.getInfoDetailPayment !== {}) {
        //       // console.log(200)
        //       // console.log(this.getInfoDetailPayment)
        //       this.cashDefaultActive = (this.getPaymentsCash.map(a=>{
        //         if(this.getInfoDetailPayment.cash !== null && a.type === 'cash') {
        //           if(a.id === this.getInfoDetailPayment.cash.id) {
        //             return a;
        //           }
        //         }
        //         if(this.getInfoDetailPayment.bank !== null && a.type === 'bank') {
        //           if ((a.id === this.getInfoDetailPayment.bank.id)) {
        //             return a
        //           }
        //         }
        //       })).filter(a => a !== undefined) [0];
        //       // console.log(300)
        //       // console.log(this.cashDefaultActive)
        //     }
        //   });
        // } else {
        //   if(this.getPaymentsCash.length !== 0) {
        //     this.cashDefaultActive = (this.getPaymentsCash.map(a=>{
        //       // console.log(a);
        //       if(this.getInfoDetailPayment.cash !== null && a.type === 'cash') {
        //         if(a.id === this.getInfoDetailPayment.cash.id) {
        //           return a;
        //         }
        //       }
        //       if(this.getInfoDetailPayment.bank !== null && a.type === 'bank') {
        //         if ((a.id === this.getInfoDetailPayment.bank.id)) {
        //           return a
        //         }
        //       }
        //     })).filter(a => a !== undefined) [0];
        //   }
        // }
        // return null;
      });
      if(this.$refs.activity) {
        this.$refs.activity.renderActivity();
      }
    },
    getFormDate(date) {
      if(date !== null && (""+date).length !== 0) {
        return moment(date).format("DD.MM.YYYY, H:mm");
      }
      return  ""
    },
    getFormDateDMY(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    getAccountName() {
      if(this.getInfoDetailPayment.account !== null && this.getInfoDetailPayment.account !== undefined) {
        let text = (""+this.getInfoDetailPayment.account.map(ac=> {return ac.id + ": " + ac.name + "<br />"}));
        text = text.replaceAll(",", "")
        return text;
      }

    },
    chatAddFile(file) {
      let idFiles = this.getInfoDetailPayment.files.map(a=>{return a.id});
      file.map(a=> {
        idFiles.push(a.id);
      })

      this.axiosPaymentRemoveFile({id: this.getInfoDetailPayment.id,filesId: idFiles}).then(()=>{
        this.renderNew()
      })
    },
    emitAddFile(files) {
      console.log(files);
      if(this.parent_id !== null) {
        for(let i=0; i<files.length; i++) {
          if(files[i].file_type === 'FOLDER')
            this.loadAddFolder1 = true
          files[i]["parent_id"] = this.parent_id;
        }
      } else {
        for(let i=0; i<files.length; i++) {
          if(files[i].file_type === 'FOLDER')
            this.loadAddFolder1 = true
        }
      }
      if(!this.idPayment) {
        this.showLoad();
      } else {
        this.showLoader = true;
      }
      this.axiosAddFilesToObject({model: 'Payment', model_id: this.getInfoDetailPayment.id, files: files}).then(()=> {
        this.loadAddFolder1 = false
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
        this.renderNew();
      }).catch(()=> {
        if(!this.idPayment) {
          this.hideLoad();
        } else {
          this.showLoader = false;
        }
      })
      // this.axiosPaymentAddFiles({id: this.getInfoDetailPayment.id, fileInPayment: this.getInfoDetailPayment.files, file: files}).then(()=> {
      //   this.loadAddFolder1 = false
      //   if(!this.idPayment) {
      //     this.hideLoad();
      //   } else {
      //     this.showLoader = false;
      //   }
      //   this.renderNew();
      // }).catch(()=> {
      //   if(!this.idPayment) {
      //     this.hideLoad();
      //   } else {
      //     this.showLoader = false;
      //   }
      // })
    },
    onChangeLinked() {
      /* console.log('onChangeLinked', 
      this.getInfoDetailPayment.linked_payments,
      this.getInfoDetailPayment.linked_invoices,
      this.getInfoDetailPayment.linked_owners); */
      this.axiosChangePaymentLinked({
        id: this.getInfoDetailPayment.id,
        linked_payments: this.getInfoDetailPayment.linked_payments.map(el=>el.id),
        linked_invoices: this.getInfoDetailPayment.linked_invoices.map(el=>el.id),
        linked_owners: this.getInfoDetailPayment.linked_owners.map(el=>el.id)
      })
    }
  },
  mounted() {
    // let textRoute = this.$route.path;
    // let idTask = textRoute.replace(/[^0-9]/gim,'');
    // this.axiosGetFullInfoForDetailPayment(idTask).then(()=> {
    //   this.keyRender++;
    // });


    if(!this.getPaymentsCash.length) {
      this.axiosGetPaymentCash().then(()=> {
        // console.log(100)
        // console.log(this.getPaymentsCash)
        // if(this.getInfoDetailPayment !== {}) {
        //   // console.log(200)
        //   // console.log(this.getInfoDetailPayment)
        //   this.cashDefaultActive = (this.getPaymentsCash.map(a=>{
        //     if(this.getInfoDetailPayment.cash !== null && a.type === 'cash') {
        //       if(a.id === this.getInfoDetailPayment.cash.id) {
        //         return a;
        //       }
        //     }
        //     if(this.getInfoDetailPayment.bank !== null && a.type === 'bank') {
        //       if ((a.id === this.getInfoDetailPayment.bank.id)) {
        //         return a
        //       }
        //     }linked-wrap
        //   })).filter(a => a !== undefined) [0];
        //   // console.log(300)
        //   // console.log(this.cashDefaultActive)
        // }
      });
    }
    this.renderNew();
  },

}
</script>

<style scoped lang="scss">
  @import "paymentDetail";
  .h36-async {
    /deep/ {
      .multiselect__tags {
        height: 36px;
        padding: 0px 40px 0 8px !important;
      }
    }
  }
  .counterparty-svg {
    position: absolute;
    right: 23px;
    bottom: 11px;
    path:first-child {
      stroke: var(--color-dark)
    }
  }
  .button-show-add-counterparty {
    position: absolute;
    top: 0;
    right: 0;
  }
  .add-client-modal {
    z-index: 400;
    position: fixed;
    top: 56px;
    height: calc(100vh - 56px);
    left: 0;
    overflow-y: auto;
  }
  .dart-mode {
    .bg-block {
      svg {
        path {
          fill: var(--color-white-always)
        }
      }
    }
    .block-button-type {
      .active {
        color: var(--color-white-always) !important
      }
    }
  }
</style>